import Header from '../Header/Header';
import { getIcon, Loader } from '@ohif/ui';
import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { Formik, Form, ErrorMessage, FieldArray, Field } from 'formik';
import { appointmentFormSchema } from "../Utils/schema/schema"
import { SuccessModal } from '@ohif/ui';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _appointmentUrls, _commonUrls, _modalityQues, _modalityUrls, _patientUrls } from '@custom/Utils/constants/apiUrls';
import { phoneNumberRegex } from '@custom/Hospital/schema';
import { AppDispatch, RootState } from './../store/store';
import addEditAppointment from '@custom/rtk-apis/appointment/addEditAppointment';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from '@custom/store/slices/Appointment/addEditAppointmentSlice';
import { servicesManager } from '../../app/src/App';
import { customStyle, getCurrencyContact, getLocalPhoneNumber } from '@custom/Utils/utils';
import moment from 'moment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, InputLabel, FormControl, MenuItem, Select, Autocomplete, Chip, Tooltip } from '@mui/material';
import SortIcon from '@mui/icons-material/Sort';
import { useTheme } from "../../ui/src/contextProviders"
import { fetchPatientCount, postMWLItems, postPatientData } from './mwlHelperMethods';
import getPrice from '@custom/rtk-apis/price/getPrice';
import getReferringDoctors from '@custom/rtk-apis/appointment/getReferringDoctors';
import getInvestigationApi from '@custom/rtk-apis/billing/getInvestigation';
import getPackage from '@custom/rtk-apis/billing/getBilling';
import addInvoiceApi from '@custom/rtk-apis/billing/invoice/addInvoice';
import getUrgencyApi from '@custom/rtk-apis/billing/urgency/getUrgency';
import getConsultationCharges from '@custom/rtk-apis/billing/consultation/getConsultationCharges';
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';
import CryptoJS from 'crypto-js';
import fetchActiveMachineList from '@custom/rtk-apis/activeMachine/activeMachineList';

interface PricingResult {
  modality: string;
  studyRegion: string;
  machineName: string;
  price: number;
  questions: {
    key: string;
    label: string;
    for: string;
  }[];
}

interface PricingResponse {
  status: string;
  result: PricingResult[];
  loading: boolean,
  error: string;
  msg: string;
}

const AddEditAppointments = () => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate();
  const location = useLocation();
  const formRef = useRef(null);
  const { result: pricingData, loading: pricingLoading, error } = useSelector(
    (state: RootState) => state.getPriceSliceResponse as PricingResponse
  );
  const modalityStudyResponse = useSelector((state: RootState) => state?.getModalityStudySliceResponse);
  const { data: machineList, loading: machineLoading, error: machineError, total } = useSelector((state: RootState) => state.ActiveMachinelistSliceResponse);
  const urgencyData = useSelector((state: RootState) => state?.getUrgencyResponse?.result || []);
  const getConsultationChargesData = useSelector((state: RootState) => state?.getConsultationChargesResponse?.result?.data || []);

  const getInvestigationData = useSelector(
    (state: RootState) => state?.getInvestigationResponse || []
  );
  const getBillingPackageData = useSelector(
    (state: RootState) => state?.getPackageResponse || []
  );
  const downloadInvoiceData = useSelector(
    (state: RootState) => state?.downloadInvoiceResponse || []
  );
  const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
  const { uiNotificationService } = servicesManager.services;
  const isDarkMode = useTheme();
  const [countryCode, setCountryCode] = useState({
    billingWhatsappNumberCountryCode: "+91",
    billingPhoneNumberCountryCode: "+91",
    billingAlternateNumberCountryCode: "+91"
  });
  const [patientID, setPatientID] = useState('');
  const [modalityList, setModalityList] = useState([]);
  const [timeSlot, setTimeSlot] = useState([]);
  const [commonData, setCommonData] = useState({});
  const [state, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [sameAsPhoneNo, setSameAsPhoneNo] = useState(false);
  const [sameAsHomeAddress, setSameAsHomeAddress] = useState(false);
  const [patientDetails, setPatientDetails] = useState({});
  const [MWLPayload, setMWLPayload] = useState({});
  const [patientList, setPatientList] = useState([]);
  const [edit, setIsEdit] = useState(false);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [invoiceId, setInvoiceId] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [combinedModalities, setCombinedModalities] = useState<string[]>([]);
  const [combinedRegions, setCombinedRegions] = useState<string[]>([]);
  const [isDataAvailable, setIsDataAvailable] = useState<boolean>(true);
  const [fieldData, setFieldData] = useState({
    UHID: '',
    patientId: '',
    patientName: '',
    contactNumberCountryCode: '+91',
  });
  const [isContactNumberCountryCodeDisabled, setIsContactNumberCountryCodeDisabled] = useState(false);
  const [modalityData, setModalityData] = useState('');
  const [filteredCombinedModalities, setFilteredCombinedModalities] = useState<string[]>([]);
  const [selectedReferringDoctor, setSelectedReferringDoctor] = useState("");
  const [referringDoctorData, setReferringDoctorData] = useState({});
  const [referringDoctorList, setReferringDoctorList] = useState([]);
  const [referringDoctorDiscountList, setReferringDoctorDiscountList] = useState([]);
  const [sortOrder, setSortOrder] = useState('asc');
  const [fields, setFields] = useState([
    { id: 0, modality: "", studyRegion: "", machineName: "", date: "", time: "", price: "" },
  ]);
  const [consultationCharges, setConsultationCharges] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>('+91');
  const [extraModalitiesToSendMWL, setExtraModalitiesToSendMWL] = useState<string[]>([]);
  const { userData, mode } = location?.state || {};

  const [appointmentType, setAppointmentType] = useState(
    userData?.appointmentType || "investigation_with_modality"
  );

  const investigationOptions = [
    ...(Array.isArray(getInvestigationData?.result?.data)
      ? getInvestigationData.result.data.map((item) => item["Package Name"])
      : []),
    ...(Array.isArray(getBillingPackageData?.result?.data)
      ? getBillingPackageData?.result?.data.map((item) => item.packageName)
      : [])
  ];

  const sortOptions = (options) => {
    const sortedOptions = [...options];
    sortedOptions.sort((a, b) => {
      if (sortOrder === 'asc') {
        return a.localeCompare(b);
      } else {
        return b.localeCompare(a);
      }
    });
    return sortedOptions;
  };

  const addMoreFields = (additionalData) => {
    const newId = fields.length > 0 ? Math.max(...fields.map(field => field.id)) + 1 : 0;
    const newField = {
      id: newId,
      modality: "",
      studyRegion: "",
      machineName: "",
      date: "",
      time: "",
      price: "",
    };
    setFields([...fields, newField]);
    additionalData.push({
      modality: "",
      studyRegion: "",
      machineName: "",
      date: "",
      time: "",
      price: "",
      quesInfo: []
    });
  };

  const mergeUniqueModalities = (newModalities: string[]) => {
    setCombinedModalities((prev) => Array.from(new Set([...prev, ...newModalities])));
    setFilteredCombinedModalities((prev) => Array.from(new Set([...prev, ...newModalities])));
  };

  useEffect(() => {
    if (pricingData?.length) {
      const modalities = Array.from(new Set(pricingData?.map((item) => item.modality)));
      setCombinedModalities(modalities);
    }
  }, [pricingData]);


  useEffect(() => {
    const fetchContactNumber = async () => {
      const res = await fetchUserData(location?.state?.contactNumber);
      if (res) {
        setFieldData({
          UHID: res?.UHID || '',
          patientId: res?.patientId || '',
          patientName: res?._id || '',
          contactNumberCountryCode: res?.contactInfo?.dialCode
        })
        setPatientID(res?._id);
      }
    };
    if (location?.state?.contactNumber) {
      fetchContactNumber();
    }
  }, [location?.state])

  useEffect(() => {
    if (userData) {

      setPatientDetails({
        gender: userData?.gender,
        dob: userData?.dob,
        billingInfo: userData?.contactInfo
      })
      setPatientID(userData?._id)
      if (userData && Object.keys(userData).length > 0) {
        if (userData?.billingInfo?.country) {
          fetchStates(userData?.billingInfo?.country, '', 'state')
        }
        if (userData?.billingInfo?.country && userData?.billingInfo?.state) {
          fetchStates(userData?.billingInfo?.country, userData?.billingInfo?.state, 'city')
        }
        if (userData?.modality) {
          fetchModalityQuestions(userData?.modality)
        }
        setIsEdit(true);
      }
    }
  }, [userData, commonData])

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      setCommonData(commonData?.result);
      setPriorityOptions(commonData?.result?.priorityOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchStates = async (country, state, type) => {
    const response: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.statecity, body: { type: type, countryCode: country, stateCode: state }, headerType: 'json' })
    if (response?.status) {
      if (type === 'state') {
        setStates(response.result);
      }
      else {
        setCities(response.result)
      }
    }
  }

  useEffect(() => {
    fetchCommonData();
    dispatch(getPrice({from: 'appointment', modality: "", studyRegion: "" }));
    dispatch(getPackage({}));
    dispatch(getInvestigationApi());
    dispatch(getUrgencyApi());
    dispatch(getConsultationCharges());
    dispatch(fetchActiveMachineList({ limit: 30, pageNumber: 1, search: '' }));
    dispatch(getBillingGeneralSettings());
    dispatch(getReferringDoctors()).then((response) => {
      setReferringDoctorList(response?.payload?.result[0]?.doctors.map((doctor) => doctor.doctorName) || []);
      console.log("response?.payload?.result[0]?.doctors ", response?.payload?.result[0]?.doctors);
      setReferringDoctorDiscountList(response?.payload?.result[0]?.doctors || []);
    });
  }, []);

  useEffect(() => {
    if (billingGeneralSettingsData?.status === 'success' && billingGeneralSettingsData?.result?.currency) {
      const newCountryCode = getCurrencyContact(billingGeneralSettingsData.result.currency);
      setSelectedCountryCode(newCountryCode);
    }
  }, [billingGeneralSettingsData]);

  useEffect(() => {
    if (getConsultationChargesData?.charges) {
      setConsultationCharges(getConsultationChargesData.charges);
    }
  }, [getConsultationChargesData]);

  useEffect(() => {
    if (pricingData?.length) {
      const modalities = Array.from(new Set(pricingData?.map((item) => item.modality)));
      mergeUniqueModalities(modalities);
    }
  }, [pricingData]);

  useEffect(() => {
    if (modalityStudyResponse?.result?.modalities) {
      const addedModalities = modalityStudyResponse?.result?.modalities;
      mergeUniqueModalities(addedModalities);
    }
  }, [modalityStudyResponse]);

  const fetchModalityQuestions = async (modalities, gender, existingQuestions = []) => {
    if (!Array.isArray(modalities) || modalities.length === 0) {
      return existingQuestions.length > 0 ? existingQuestions : userData?.quesInfo || [];
    }

    const modalitySet = new Set(modalities.filter(Boolean));

    let allQuestions = existingQuestions.filter(
      (q) => q && q._id && modalitySet.has(q.modality)
    );

    const seenQuestionIds = new Set(allQuestions.map((q) => q._id));

    let allTimeSlots = new Set(timeSlot.map((slot) => JSON.stringify(slot)));
    const userQuestionsById = new Map();
    if (userData?.quesInfo) {
      userData.quesInfo.forEach((q) => {
        if (q._id && q.answer) {
          userQuestionsById.set(q._id, q);
        }
      });
    }

    for (const modality of modalitySet) {
      if (!modality) continue;

      const modalityItem = pricingData?.find((item) => item.modality === modality);
      if (!modalityItem) {
        const userQuestions = userData?.quesInfo?.filter((q) => q.modality === modality) || [];
        userQuestions.forEach((q) => {
          if (!seenQuestionIds.has(q._id)) {
            allQuestions.push(q);
            seenQuestionIds.add(q._id);
          }
        });
        continue;
      }

      if (modalityItem.questions) {
        const currQuestions = modalityItem.questions.filter(
          (ques) =>
            ques?.for === "both" || ques.for?.toLowerCase() === gender?.toLowerCase()
        );
        const transformedQuestions = currQuestions.map((ques) => {
          const questionId = `${modality}-${ques.key}`;
          const existingQuestion = userQuestionsById.get(questionId) || allQuestions.find((q) => q._id === questionId);
          return {
            _id: questionId,
            modality: modality,
            question: ques.label,
            answer: existingQuestion?.answer || "",
          };
        });

        transformedQuestions.forEach((newQuestion) => {
          if (!seenQuestionIds.has(newQuestion._id)) {
            allQuestions.push(newQuestion);
            seenQuestionIds.add(newQuestion._id);
          }
        });
      }

      if (modalityItem?.timeSlot) {
        modalityItem.timeSlot.forEach((slot) => allTimeSlots.add(JSON.stringify(slot)));
      }
    }

    if (allTimeSlots.size > 0) {
      setTimeSlot(Array.from(allTimeSlots).map((slot) => JSON.parse(slot)));
    }

    return allQuestions.length > 0 ? allQuestions : userData?.quesInfo || [];
  };

  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };

  type UserData = {
    UHID: string;
    patientId: string;
    _id: string;
    patientName: string;
  };

  const fetchUserData = async (contactNumber) => {
    try {
      setTitle('Fetching data...');
      setLoading(true);

      const AES_SECRET_KEY = process.env.NEXT_PUBLIC_AES_SECRET_KEY;
      const AES_IV = process.env.NEXT_PUBLIC_AES_IV;

      const decryptData = (encryptedData) => {
        try {
          if (!AES_SECRET_KEY || !AES_IV) {
            return null;
          }

          const key = CryptoJS.enc.Hex.parse(AES_SECRET_KEY);
          const iv = CryptoJS.enc.Hex.parse(AES_IV);

          const cipherParams = CryptoJS.enc.Hex.parse(encryptedData);
          const decrypted = CryptoJS.AES.decrypt({ ciphertext: cipherParams }, key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          });

          const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

          if (!decryptedText) {
            return null;
          }

          return decryptedText;
        } catch (error) {
          return null;
        }
      };

      const response = await apiRequest({
        method: 'GET',
        endUrl: _patientUrls.list,
        headerType: 'json',
        query: {
          hospitalId: sessionStorage.getItem("hospitalId") || localStorage.getItem("hospitalId"),
          searchQ: contactNumber,
          from: 'appointment'
        }
      });

      let patientsList = [];
      if (typeof response?.result === 'string') {
        const decryptedData = decryptData(response.result);
        if (decryptedData) {
          try {
            const parsedData = JSON.parse(decryptedData);
            if (parsedData.list && Array.isArray(parsedData.list)) {
              patientsList = parsedData.list;
            } else {
              setIsDataAvailable(false);
              setPatientList([]);
              uiNotificationService.show({
                title: 'Appointment',
                message: 'No valid patient data found',
                type: 'error',
              });
              return null;
            }
          } catch (parseError) {
            setIsDataAvailable(false);
            setPatientList([]);
            uiNotificationService.show({
              title: 'Appointment',
              message: 'Error parsing patient data',
              type: 'error',
            });
            return null;
          }
        } else {
          setIsDataAvailable(false);
          setPatientList([]);
          uiNotificationService.show({
            title: 'Appointment',
            message: 'Failed to decrypt patient data',
            type: 'error',
          });
          return null;
        }
      } else if (response?.result?.list) {
        patientsList = response.result.list;
      }

      if (!patientsList.length) {
        setIsDataAvailable(false);
        setPatientList([]);
        uiNotificationService.show({
          title: 'Appointment',
          message: response?.msg,
          type: 'error',
        });
        return null;
      }

      const formattedPatients = patientsList.map((userData) => ({
        id: userData?._id,
        patientId: userData?.patientId,
        UHID: userData?.UHID,
        name: `${userData?.firstName} ${userData?.lastName}`,
        gender: userData?.gender,
        dob: userData?.dob,
        billingInfo: userData?.contactInfo,
        contactNumberCountryCode: userData?.contactInfo?.dialCode,
      }));
      setPatientList(formattedPatients);

      const firstPatient = patientsList[0];
      setPatientDetails({
        gender: firstPatient?.gender,
        dob: firstPatient?.dob,
        billingInfo: firstPatient?.contactInfo,
        name: `${firstPatient?.firstName} ${firstPatient?.lastName}`,
      });

      setIsDataAvailable(true);

      if(formattedPatients.length > 1) {
        return {};
      }

      return {
        _id: firstPatient?._id,
        contactNumber: getLocalPhoneNumber(firstPatient?.contactInfo?.mobileNo),
        patientId: firstPatient?.patientId,
        UHID: firstPatient?.UHID,
        patientName: `${firstPatient?.firstName} ${firstPatient?.lastName}`,
        contactNumberCountryCode: firstPatient?.contactInfo?.dialCode,
      };
    } catch (error) {
      console.error("Error fetching data:", error);
      setPatientList([]);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location?.state?.contactNumber) {
      fetchUserData(location?.state?.contactNumber);
    }
  }, [location?.state?.contactNumber]);

  const { result, msg, status } = useSelector((state: RootState) => {
    return state?.addEditApointmentResponse;
  });

  useEffect(() => {
    const isPacsActive = localStorage.getItem('local_pacs_access_token') || sessionStorage.getItem('local_pacs_access_token');
    if (isPacsActive && appointmentType === 'investigation_with_modality' && Object?.keys(MWLPayload).length > 0 && Object?.keys(result).length > 0) {
      const appointmentId = result?._id
      setTitle(msg)
      sendToMWLHandler(MWLPayload, appointmentId);
      if(extraModalitiesToSendMWL.length > 0) {
        extraModalitiesToSendMWL.forEach((item) => {
          const mwlDetails = {
          uhid: MWLPayload?.uhid,
          modality: item?.modality,
          studyRegion: item?.studyRegion,
          patientId: MWLPayload?.patientId,
          name: MWLPayload?.name,
          dob: MWLPayload?.dob,
          age: MWLPayload?.age,
          gender: MWLPayload?.gender,
          machineName: item?.machineName,
        };
         sendToMWLHandler(mwlDetails, appointmentId);
        });
      }
    }
    if (status === 'ERROR') {
      uiNotificationService.show({
        title: 'Appointment',
        message: msg,
        type: 'error',
      });
    }

    dispatch(closeModal())
  }, [status, result, MWLPayload])

  const isDST = (a) => {
    let d = new Date(a);
    let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();

    if (d.getTimezoneOffset() !== Math.max(jan, jul)) {
      return true;
    } else {
      return (d.getTimezoneOffset() - jul) / 60;
    }
  }
  const formatDate = (date, givenFormat, requiredFormat) => {
    return moment(date).format(requiredFormat);
  }
  const convertDateIntoUTC = (date, time) => {
    const timeArray = time.split("-")
    let localDate = formatDate(date.format("YYYY-MM-DD"), null, 'YYYY-MM-DD') + ' ' + timeArray[0].trim() + ':00';
    let utcDate: any;
    let dst = isDST(date);
    if (typeof dst !== 'boolean') {
      utcDate = moment(localDate).utc().subtract(dst, 'hours').format('');
    } else {
      utcDate = moment.utc(moment(localDate)).format('');
    }
    let splitUTCDate = utcDate.split('Z');
    return splitUTCDate[0];
  }
  const makeTime = (date, time, type) => {
    const timeArray = time.split("-")
    return type === 'startDate' ? `${date}T${timeArray[0].trim()}:00` : `${date}T${timeArray[timeArray.length - 1].trim()}:00`
  }

  const changeAppointmentStatus = async (appointmentId) => {
    const response = await apiRequest(
      {
        method: 'PATCH',
        endUrl: _appointmentUrls.updateStaus,
        headerType: 'json',
        params: { _id: appointmentId },
        body: { status: "Scheduled" }
      }
    )
    if (response.status) {
      setModal(true)
      setTimeout(() => {
        setModal(false)
        setTitle("")
        navigate("/appointments")
      }, 500)
    } else {
      uiNotificationService.show({
        title: 'Status',
        message: response?.msg,
        type: 'error',
      });
    }
  }

  async function sendToMWLHandler(item, appointmentId) {
    setLoading(true);
    try {
      const countRes = await fetchPatientCount(item?.uhid);
      if (!countRes) {
        changeAppointmentStatus(appointmentId)
      } else {
        setModal(true)
        setTimeout(() => {
          setModal(false)
          setTitle("")
          if (mode === 'edit') {
            navigate(`/appointments`);
          }
        }, 500);
      }
      let aeTitle = '';
      if (item.machineName) {
        const machineGroup = machineList.find((group) => group.machineType === item.modality);
        if (machineGroup) {
          const machine = machineGroup.machines.find((m) => m.machineName === item.machineName);
          aeTitle = machine ? machine.aeTitle : '';
        }
      }
      const mwlDetails = {
        patId: item?.uhid,
        patAge: `${String(item?.age).padStart(3, "0")}Y`,
        modality: item?.modality,
        stepProcedureDisc: item?.studyRegion,
        accessionNumber: item?.patientId,
        aeTitle: aeTitle,
        machineName: item?.machineName,
      };

      if (countRes?.count > 0) {
        const mwlRes = await postMWLItems(mwlDetails);
        if (!mwlRes) {
          changeAppointmentStatus(appointmentId)
        }
      } else {
        const patientDetails = {
          patName: item?.name,
          patId: item?.uhid,
          patIdIssuer: 'QSS',
          patDob: item?.dob?.replace(/-/g, ''),
          patSex: item?.gender === 'Male' ? 'M' : item.gender === 'Female' ? 'F' : 'O',
        };

        const isPatAdded = await postPatientData(patientDetails);

        if (isPatAdded) {
          const mwlRes = await postMWLItems(mwlDetails);
          if (!mwlRes) {
            changeAppointmentStatus(appointmentId)
          }
        } else {
          changeAppointmentStatus(appointmentId)
        }
      }
    } catch (error) {
      console.log(error, "error while MWL api")
    } finally {
      setLoading(false);
    }
  }

  const getUrgencyPrice = (selectedPriority) => {
    if (!urgencyData || !selectedPriority) return 0;
    const urgencyItem = urgencyData.find(item => item.case.toLowerCase() === selectedPriority.toLowerCase());
    return urgencyItem ? urgencyItem.price : 0;
  };

  const getSelectedServicesIncluded = (selectedPackages) => {
    if (!selectedPackages || !Array.isArray(selectedPackages)) return [];

    const allPackages = [
      ...(getBillingPackageData?.result?.data || []).map(item => ({
        name: item.packageName,
        services: item.servicesIncluded
      })),
      ...(getInvestigationData?.result?.data || []).map(item => ({
        name: item["Package Name"],
        services: item["Services Included"].split(", ")
      }))
    ];

    const selectedServices = selectedPackages
      .map(packageName => {
        const pkg = allPackages.find(p => p.name === packageName);
        return pkg ? pkg.services : [];
      })
      .flat();

    return selectedServices.filter((item, index) => selectedServices.indexOf(item) === index);
  };

  const handleSaveForm = async (values) => {
    try {
      const quesInfoToSubmit = values?.quesInfo
        .filter((q) => q && q._id)
        .map(({ _id, question, answer }) => ({
          _id,
          question,
          answer: answer || '',
        }));
      const hospitalId =
        sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      const formattedExtraModalities =
        values.extraModalities?.map((item) => ({
          modality: item.modality || '',
          studyRegion: item.studyRegion || '',
          price: item.price ? Number(item.price) : 0,
          appointmentDate: item.date ? item.date.format('YYYY-MM-DD') : '',
          appointmentTime: item.time || '',
          machineName: item?.machineName,
        })) || [];
      const selectedServiceIncluded = getSelectedServicesIncluded(
        values.serviceInvestigation
      );
      const urgencyPrice = getUrgencyPrice(values.priority);

      let obj = {
        patientId: patientID,
        hospitalId: hospitalId,
        date: values?.date?.format('YYYY-MM-DD'),
        modality: values?.modality,
        doctorName: values?.consultingDoctorName,
        doctorId: 'Doc0123',
        studyRegion: values?.studyRegion,
        serviceInvestigation: values?.serviceInvestigation || [],
        investigationPrice: values?.investigationPrice,
        selectedServiceIncluded:
          selectedServiceIncluded.length > 0 ? selectedServiceIncluded : [],
        referDoctor: values?.referringDoctor,
        referDoctorDialCode: '+91',
        referDoctorContact: getLocalPhoneNumber(values?.referringDoctorContactNumber),
        referDoctorSpec: values?.referringDoctorSpeciality,
        billingInfo: {
          billingName: values?.billingName,
          addressLine1: values?.addressLine1,
          country: values?.billingCountry,
          state: values?.billingState,
          city: values?.billingCity,
          zipCode: values?.billingZipCode,
          dialCode: values?.billingPhoneNumberCountryCode,
          mobileNo: getLocalPhoneNumber(values?.billingPhoneNumber),
          alternateMobileDialCode: values?.billingAlternateNumberCountryCode,
          alternateMobileNo: getLocalPhoneNumber(values?.billingAlternateNumber),
          whatsappNoDialCode: values?.billingWhatsappNumberCountryCode,
          whatsappNo: getLocalPhoneNumber(values?.billingWhatsappNumber),
        },
        priority: values?.priority,
        caseStudyPrice: urgencyPrice,
        price: values?.price,
        ...(
          appointmentType !== 'consultation' && quesInfoToSubmit.length > 0
            ? { quesInfo: quesInfoToSubmit }
            : {}
        ),
        extraModalities:
          formattedExtraModalities.length > 0 ? formattedExtraModalities : undefined,
        appointmentType: appointmentType,
      };

      if (appointmentType === 'consultation') {
          obj = {
            ...obj,
            // doctorId: values?.consultingDoctorName,
            // doctorName:   getConsultationChargesData?.charges?.filter((charge) => (
            //   charge.radiologistId === values?.consultingDoctorName
            // ))?.[0]?.radiologistName ||  "",
            doctorName: values?.consultingDoctorName,
            time: makeTime(values?.date?.format('YYYY-MM-DD'), values.time, 'startDate'),
            endTime: makeTime(values?.date?.format('YYYY-MM-DD'), values.time, 'endDate'),
            convertStartDateInUTC: convertDateIntoUTC(values?.date, values?.time),
          };
      }
      if (appointmentType === 'investigation_with_modality') {
        obj = {
          ...obj,
          time: makeTime(values?.date?.format('YYYY-MM-DD'), values.time, 'startDate'),
          endTime: makeTime(values?.date?.format('YYYY-MM-DD'), values.time, 'endDate'),
          convertStartDateInUTC: convertDateIntoUTC(values?.date, values?.time),
          machineName: values?.machineName,

        };
      }

      if (mode === 'edit') {
        obj['_id'] = userData?._id;
      }
      setLoading(true);
      setTitle(mode === 'edit' ? 'Updating appointment...' : 'Saving appointment...');
      const response = await dispatch(addEditAppointment(obj));
      setLoading(false);

      if (response?.payload?.status === 'ERROR') {
        const displayMsg =
          msg === '\"patientId\" is required'
            ? 'Patient Name is required'
            : msg;
        uiNotificationService.show({
          title: 'Appointment',
          message: displayMsg,
          type: 'error',
        });
        return;
      }
      console.log('vvvvvvvvv',values)
      const isPacsActive =
        localStorage.getItem('local_pacs_access_token') ||
        sessionStorage.getItem('local_pacs_access_token');
      if (isPacsActive) {
        const patId = response?.payload?.result?.patientInfo?.patientId;
        const age = response?.payload?.result?.patientInfo?.age;
        const item = {
          uhid: values?.UHID,
          modality: values?.modality,
          studyRegion: values?.studyRegion,
          patientId: patId || '',
          name: patientDetails?.name,
          dob: patientDetails?.dob,
          age: age || '',
          gender: patientDetails?.gender,
          machineName: values?.machineName,
        };
        setMWLPayload(item);
        setExtraModalitiesToSendMWL(formattedExtraModalities);
      }

      const appointmentId = response?.payload?.result?._id;
      setInvoiceId(appointmentId);

      if (appointmentId && mode !== 'edit') {
        setLoading(true);
        const invoiceResponse = await dispatch(addInvoiceApi({ appointmentId }));
        setLoading(false);

        if (invoiceResponse?.payload?.status === 'ERROR') {
          uiNotificationService.show({
            title: 'Invoice',
            message: invoiceResponse?.payload?.msg || 'An error occurred.',
            type: 'error',
          });
          return;
        }

        setTitle('Appointment and invoice saved successfully.');
        navigate(`/invoice/edit/${invoiceResponse?.payload?.data?._id}`);
      } else if (!appointmentId) {
        uiNotificationService.show({
          title: 'Invoice Creation',
          message: 'Appointment saved, but no ID returned to create invoice.',
          type: 'warning',
        });
      } else if (mode === 'edit') {
        setTitle('Appointment updated successfully.');
        setModal(true);
        setTimeout(() => {
          setModal(false);
          navigate('/appointments');
        }, 500);
      }

    } catch (error) {
      setLoading(false);
      uiNotificationService.show({
        title: 'Appointment',
        message: 'Something went wrong. Please try again later.',
        type: 'error',
      });
    }
  };

  const cancel = () => {
    navigate("/appointments");
  }

  const capitalizeWords = (str) =>
    str
      ? str
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
      : '';

  const selectFormatTime = (startTime, endTime) => {
    return `${moment(startTime).format("HH:mm")} - ${moment(endTime).format("HH:mm")}`;
  }

  const getPatientName = (mode, userData) => {
    if (mode === 'create') {
      return userData?.firstName && userData?.lastName
        ? `${userData.firstName} ${userData.lastName}`
        : '';
    }

    const patientInfoName = userData?.patientInfo?.firstName && userData?.patientInfo?.lastName
      ? `${userData.patientInfo.firstName} ${userData.patientInfo.lastName}`
      : '';
    return patientInfoName || '';
  };

  useEffect(() => {
    const patientInfoName = getPatientName(mode, userData);
    setPatientList([
      {
        id: 'defaultId',
        name: patientInfoName,
      },
    ]);
  }, [userData]);

  useEffect(() => {
    if (!userData?.modality) return;

    if (mode !== 'create') {
      const modalityData: string[] = Array.isArray(userData.modality)
        ? userData.modality.filter((item): item is string => typeof item === 'string')
        : [userData.modality].filter((item): item is string => typeof item === 'string');

      mergeUniqueModalities(modalityData);
    }
  }, [userData]);

  useEffect(() => {
    if (!userData?.studyRegion) return;

    const studyRegionData: string[] = Array.isArray(userData.studyRegion)
      ? userData.studyRegion.filter((item): item is string => typeof item === 'string')
      : [userData.studyRegion].filter((item): item is string => typeof item === 'string');

    const uniqueRegions = Array.from(new Set(studyRegionData));
    setCombinedRegions(uniqueRegions);
  }, [userData]);

  const formatExtraModalityTime = (appointmentTime) => {
    if (!appointmentTime) return "";
    return appointmentTime.includes("-")
      ? appointmentTime
      : `${moment(appointmentTime).format("HH:mm")} - ${moment(appointmentTime).add(1, "hour").format("HH:mm")}`;
  };

  const defaultCountryCode = billingGeneralSettingsData?.status && billingGeneralSettingsData?.result?.currency ? getCurrencyContact(billingGeneralSettingsData.result.currency) : '+91';

  let initialValues = {
    contactNumberCountryCode: mode === 'create' ? defaultCountryCode : userData?.patientInfo?.contactInfo?.dialCode || "",
    contactNumber: location?.state?.contactNumber
      ? getLocalPhoneNumber(location.state.contactNumber)
      : mode === 'create'
        ? getLocalPhoneNumber(userData?.contactInfo?.mobileNo)
        : getLocalPhoneNumber(userData?.patientInfo?.contactInfo?.mobileNo),
    UHID: mode === 'create' ? userData?.UHID : userData?.patientInfo?.UHID || fieldData?.UHID,
    patientId: mode === 'create' ? userData?.patientId : userData?.patientInfo?.patientId || fieldData?.patientId,
    patientName: getPatientName(mode, userData),
    date: userData?.date ? dayjs(userData?.date) : dayjs(),
    time: userData?.time && userData?.endTime ? selectFormatTime(userData?.time, userData?.endTime) : "",
    modality: userData?.modality || "",
    studyRegion: userData?.studyRegion || "",
    machineName: userData?.machineName || "",
    extraModalities: userData?.extraModalities?.map(item => ({
      modality: item.modality || "",
      studyRegion: item.studyRegion || "",
      machineName: item.machineName || "",
      date: item.appointmentDate ? dayjs(item.appointmentDate) : "",
      time: formatExtraModalityTime(item?.appointmentTime),
      price: item.price || "",
    })) || [],
    consultingDoctorName: userData?.doctorName,
    referringDoctor: userData?.referDoctor || "",
    referringDoctorContactNumberCountryCode: mode === 'create' ? defaultCountryCode : userData?.referDoctorDialCode,
    referringDoctorContactNumber: getLocalPhoneNumber(userData?.referDoctorContact),
    referringDoctorSpeciality: userData?.referDoctorSpec || "",
    priority: userData?.priority || "",
    price: userData?.price || "",
    serviceInvestigation: userData?.serviceInvestigation || [],
    investigationPrice: userData?.investigationPrice || "",
    billingName: userData?.billingInfo?.billingName || "",
    addressLine1: userData?.billingInfo?.addressLine1 || "",
    billingZipCode: userData?.billingInfo?.zipCode || "",
    billingCountry: userData?.billingInfo?.country || "",
    billingState: userData?.billingInfo?.state || "",
    billingCity: userData?.billingInfo?.city || "",
    billingPhoneNumber: getLocalPhoneNumber(userData?.billingInfo?.mobileNo),
    billingPhoneNumberCountryCode: mode === 'create' ? defaultCountryCode : userData?.billingInfo?.dialCode || defaultCountryCode,
    billingAlternateNumber: getLocalPhoneNumber(userData?.billingInfo?.alternateMobileNo),
    billingAlternateNumberCountryCode: mode === 'create' ? defaultCountryCode : userData?.billingInfo?.alternateMobileDialCode || defaultCountryCode,
    billingWhatsappNumberCountryCode: mode === 'create' ? defaultCountryCode : userData?.billingInfo?.whatsappNoDialCode || defaultCountryCode,
    billingWhatsappNumber: getLocalPhoneNumber(userData?.billingInfo?.whatsappNo),
    quesInfo: userData?.quesInfo || [],
    appointmentType: userData?.appointmentType,
  };

  useEffect(() => {
    if (userData) {
      setPatientDetails({
        gender: userData?.gender,
        dob: userData?.dob,
        billingInfo: userData?.contactInfo
      });
      setPatientID(userData?._id);
      if (userData && Object.keys(userData).length > 0) {
        if (userData?.billingInfo?.country) {
          fetchStates(userData?.billingInfo?.country, '', 'state');
        }
        if (userData?.billingInfo?.country && userData?.billingInfo?.state) {
          fetchStates(userData?.billingInfo?.country, userData?.billingInfo?.state, 'city');
        }
        if (userData?.modality || userData?.extraModalities) {
          const allModalities = [
            userData?.modality,
            ...(userData?.extraModalities?.map(item => item.modality) || [])
          ].filter(Boolean);
          fetchModalityQuestions(allModalities, userData?.gender).then((questions) => {
            const timeSlots = new Set();
            allModalities.forEach(modality => {
              const modalityItem = pricingData?.find(item => item.modality === modality);
              if (modalityItem?.timeSlot) {
                modalityItem.timeSlot.forEach(slot => timeSlots.add(JSON.stringify(slot)));
              }
            });
            if (timeSlots.size > 0) {
              setTimeSlot(Array.from(timeSlots).map(slot => JSON.parse(slot)));
            }
          });
        }
        setIsEdit(true);
      }
    }
  }, [userData, commonData, pricingData]);

  useEffect(() => {
    if (modalityData) {
      let arr = [];
      arr = combinedModalities.filter((item) => item !== modalityData);
      setFilteredCombinedModalities(arr);
    } else {
      setFilteredCombinedModalities(combinedModalities);
    }
  }, [modalityData]);

  useEffect(() => {
    if (userData?.referDoctor) {
      setSelectedReferringDoctor(userData.referDoctor);
    }
  }, [userData]);

  const getAvailableStudyRegions = (modality, values, currentFieldIndex = null) => {
    if (!modality || !pricingData) return [];

    const allRegionsForModality = Array.from(
      new Set(
        pricingData
          .filter((item) => item.modality === modality)
          .map((item) => item.studyRegion)
      )
    );

    const selectedRegionsForModality = new Set();

    if (values.modality === modality && values.studyRegion && currentFieldIndex !== null) {
      selectedRegionsForModality.add(values.studyRegion);
    }

    values.extraModalities?.forEach((extraModality, index) => {
      if (
        extraModality.modality === modality &&
        extraModality.studyRegion &&
        index !== currentFieldIndex
      ) {
        selectedRegionsForModality.add(extraModality.studyRegion);
      }
    });

    const availableRegions = allRegionsForModality.filter(
      (region) => !selectedRegionsForModality.has(region)
    );

    const currentStudyRegion =
      currentFieldIndex === null
        ? values.studyRegion
        : values.extraModalities[currentFieldIndex]?.studyRegion;
    if (currentStudyRegion && !availableRegions.includes(currentStudyRegion)) {
      availableRegions.unshift(currentStudyRegion);
    }

    return availableRegions;
  };

  function modifyPrices(inputString, discountPercentage = 0, hikePercentage = 0) {
    return inputString.replace(/\d+/g, match => {
      let originalPrice = parseInt(match, 10);
      let modifiedPrice = Math.round(originalPrice * (1 + hikePercentage / 100) * (1 - discountPercentage / 100));
      return modifiedPrice;
    });
  }

  function modifyModalityStudyPrices(price, modality, studyRegion, referringDoctorData) {
    if (!referringDoctorData || !referringDoctorData.priceFields) return price;

    price = Number(price);

    for (const field of referringDoctorData.priceFields) {
      if (looseMatch(field.modality, modality) && looseMatch(field.studyRegion, studyRegion)) {
        if (field.priceDiscount) {
          const discount = parseFloat(field.priceDiscount);
          console.log(" field.priceDiscount ", price, field.priceDiscount, discount);
          if (!isNaN(discount)) {
            return price - (price * discount / 100);
          }
        } else if (field.priceHike) {
          const hike = parseFloat(field.priceHike);
          if (!isNaN(hike)) {
            return price + (price * hike / 100);
          }
        }
      }
    }

    return price; // return original price if no match or no discount/hike
  }

  function looseMatch(str1, str2) {
    return str1?.trim().toLowerCase() == str2?.trim().toLowerCase();
  }

  const calculatePrice = (modality, studyRegion, referringDoctor) => {
    let matchingPrice;

    if (referringDoctor) {
      const matchingItem = pricingData.find(
        (item) =>
          item.modality === modality &&
          item.studyRegion === studyRegion &&
          item.referringDoctor === referringDoctor
      );
      if (matchingItem) {
        matchingPrice = matchingItem.price;
      }
    }

    if (!matchingPrice) {
      const matchingItem = pricingData.find(
        (item) =>
          item.modality === modality &&
          item.studyRegion === studyRegion
      );
      matchingPrice = matchingItem?.price;
    }

    return matchingPrice;
  };

 // Helper function using local state
 const getModalitiesForRadiologist = (radiologistId) => {
  const radiologist = consultationCharges.find(
    (charge) => charge.radiologistName === radiologistId
  );
  return radiologist ? radiologist.consultationCharges?.map((item) => item.modality) : [];
};

// Helper function using local state
const getPriceForRadiologistAndModality = (radiologistId, modality) => {
  const radiologist = consultationCharges.find(
    (charge) => charge.radiologistName === radiologistId
  );
  const chargeItem = radiologist?.consultationCharges.find(
    (item) => item.modality === modality
  );

  return chargeItem ? chargeItem.charge : "";
};

  return (
    <>
      <div className='page page__full' style={
        isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header isBack={true} title={`Patient Appointment Form`}></Header>
        <div className='page__body'>
          <div className='details'>
            <div className='form form--innersec'>
              <Formik
                initialValues={initialValues}
                validationSchema={appointmentFormSchema(appointmentType, mode)}
                onSubmit={handleSaveForm}
              >
                {({
                  errors,
                  values,
                  handleChange,
                  handleBlur,
                  touched,
                  setFieldValue,
                  setFieldError,
                  setFieldTouched,
                  isSubmitting
                }) => {
                  useEffect(() => {
                    if (Object.keys(errors).length > 0 && formRef.current) {
                      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                      uiNotificationService.show({
                        title: "Appointment Form",
                        message: "Please fill all the required fields",
                        type: "error",
                      })
                    }
                  }, [isSubmitting]);

                useEffect(() => {
                  const updateQuestions = async () => {
                    const allModalities = [
                      values.modality,
                      ...values.extraModalities.map((item) => item.modality).filter(Boolean),
                    ].filter(Boolean);

                    if (allModalities.length === 0) {
                      setFieldValue("quesInfo", []);
                      return;
                    }

                    const updatedQuestions = await fetchModalityQuestions(allModalities, patientDetails?.gender);
                    setFieldValue("quesInfo", updatedQuestions);
                  };

                  if (appointmentType === "investigation_with_modality") {
                    updateQuestions();
                  } else {
                    setFieldValue("quesInfo", []);
                  }
                }, [values.modality, values.extraModalities, patientDetails?.gender, setFieldValue, appointmentType]);

                  useEffect(() => {

                    if (appointmentType === "consultation" && values.consultingDoctorName && values.modality) {
                      const price = getPriceForRadiologistAndModality(values.consultingDoctorName, values.modality);
                      setFieldValue("price", price);
                      setFieldValue("modality", values.modality); // Optional
                    }
                  }, [values.consultingDoctorName, values.modality, setFieldValue,consultationCharges]);

                  useEffect(() => {
                    if (pricingData && pricingData.length > 0) {
                      if (values.modality && values.studyRegion) {
                        const mainPrice = calculatePrice(values.modality, values.studyRegion, values.referringDoctor);
                        if (mainPrice !== undefined && mainPrice !== values.price) {
                          if (selectedReferringDoctor !== "") {
                            let discountedPrice = modifyModalityStudyPrices(mainPrice, values.modality, values.studyRegion, referringDoctorData);
                            setFieldValue("price", discountedPrice);
                          } else {
                            setFieldValue("price", mainPrice);
                          }
                        }
                      }

                      values.extraModalities?.forEach((extraModality, index) => {
                        if (extraModality.modality && extraModality.studyRegion) {
                          const extraPrice = calculatePrice(
                            extraModality.modality,
                            extraModality.studyRegion,
                            values.referringDoctor
                          );
                          if (extraPrice !== undefined && extraPrice !== extraModality.price) {
                            if (selectedReferringDoctor !== "") {
                              let extraDiscountedPrice = modifyModalityStudyPrices(extraPrice, extraModality.modality, extraModality.studyRegion, referringDoctorData);
                              setFieldValue(`extraModalities[${index}].price`, extraDiscountedPrice);
                            } else {
                              setFieldValue(`extraModalities[${index}].price`, extraPrice);
                            }
                          }
                        }
                      });
                    }
                  }, [pricingData, values, setFieldValue]);

                  useEffect(() => {
                    const updateExtraModalityQuestions = async () => {
                      const extraModalities = values.extraModalities?.map(item => item.modality).filter(Boolean) || [];
                      const allModalities = [values.modality, ...extraModalities].filter(Boolean);
                      const updatedQuestions = await fetchModalityQuestions(allModalities, patientDetails?.gender);
                      setFieldValue("quesInfo", updatedQuestions.filter(q => q !== null && q !== undefined));
                    };
                    if (values.modality || (values.extraModalities && values.extraModalities.length > 0)) {
                      updateExtraModalityQuestions();
                    } else {
                      setFieldValue("quesInfo", []);
                    }
                  }, [values.modality, values.extraModalities, patientDetails?.gender, setFieldValue]);

                  const calculateInvestigationPrice = (selectedInvestigations, doctorData) => {
                    const allPackages = [
                      ...(Array.isArray(getInvestigationData?.result?.data)
                        ? getInvestigationData.result.data.map((item) => ({
                            name: item["Package Name"],
                            price: item.Price,
                          }))
                        : []),
                      ...(Array.isArray(getBillingPackageData?.result?.data)
                        ? getBillingPackageData?.result?.data.map((item) => ({
                            name: item.packageName,
                            price: item.packagePricing,
                          }))
                        : []),
                    ];

                    const selectedPackages = selectedInvestigations.map((name) =>
                      allPackages.find((pkg) => pkg.name === name)
                    ).filter(Boolean);

                    let prices = selectedPackages.map((pkg) => pkg.price).join(", ");

                    if (Object.keys(doctorData).length > 0) {
                      let discountedPrice;
                      if (doctorData?.investigationDiscount === "--") {
                        discountedPrice = modifyPrices(prices, 0, +doctorData?.investigationHikePrice);
                      } else {
                        discountedPrice = modifyPrices(prices, +doctorData?.investigationDiscount, 0);
                      }
                      prices = discountedPrice;
                    }

                    return prices;
                  };

                  useEffect(() => {
                    if (values.serviceInvestigation && values.serviceInvestigation.length > 0) {
                      const price = calculateInvestigationPrice(values.serviceInvestigation, referringDoctorData);
                      setFieldValue("investigationPrice", price);
                    } else {
                      setFieldValue("investigationPrice", "");
                    }
                  }, [values.serviceInvestigation, referringDoctorData]);

                  // useEffect(() => {
                  //   if (values.modality || values.studyRegion) {
                  //     setFieldValue("referringDoctor", "");
                  //     setSelectedReferringDoctor("");
                  //   }
                  // }, [values.modality, values.studyRegion]);

                  const handleModalityChange = async (modalityValue, index = null, values, setFieldValue) => {
                    const allModalities = new Set([
                      values.modality,
                      ...values.extraModalities.map((item) => item.modality).filter(Boolean),
                    ]);

                    if (index === null) {
                      setFieldValue("modality", modalityValue);
                      setFieldValue("studyRegion", "");
                      setFieldValue("price", "");
                      // setFieldValue("referringDoctor", "");
                      // setSelectedReferringDoctor("");
                      if (!modalityValue || modalityValue !== values.modality) {
                        setFieldValue("time", "");
                      }
                      allModalities.delete(values.modality);
                      if (modalityValue) allModalities.add(modalityValue);
                    } else {
                      setFieldValue(`extraModalities[${index}].modality`, modalityValue);
                      setFieldValue(`extraModalities[${index}].studyRegion`, "");
                      setFieldValue(`extraModalities[${index}].price`, "");
                      const oldModality = values.extraModalities[index]?.modality;
                      allModalities.delete(oldModality);
                      if (modalityValue) allModalities.add(modalityValue);
                    }

                    const updatedQuestions = await fetchModalityQuestions(
                      Array.from(allModalities),
                      patientDetails?.gender
                    );
                    setFieldValue("quesInfo", updatedQuestions);
                  };

                  useEffect(() => {
                    const updateExtraModalityQuestions = async () => {
                      const extraModalities = values.extraModalities?.map(item => item.modality).filter(Boolean) || [];
                      const allModalities = [values.modality, ...extraModalities].filter(Boolean);

                      const updatedQuestions = await fetchModalityQuestions(allModalities, patientDetails?.gender);
                      setFieldValue("quesInfo", updatedQuestions.filter(q => q !== null && q !== undefined));
                    };

                    if (values.modality || (values.extraModalities && values.extraModalities.length > 0)) {
                      updateExtraModalityQuestions();
                    } else {
                      setFieldValue("quesInfo", []);
                    }
                  }, [values.modality, values.extraModalities, patientDetails?.gender, setFieldValue]);

                  useEffect(() => {
                    const updateExtraModalityQuestions = async () => {
                      const extraModalities = values.extraModalities?.map(item => item.modality).filter(Boolean) || [];

                      const extraQuestions = await fetchModalityQuestions(extraModalities, patientDetails?.gender);

                      const existingMainQuestions = values.quesInfo?.filter(q => !q.modality || q.modality === values.modality) || [];
                      setFieldValue("quesInfo", [...existingMainQuestions, ...extraQuestions]);
                    };

                    if (values.extraModalities && values.extraModalities.length > 0) {
                      updateExtraModalityQuestions();
                    }
                  }, [values.extraModalities, patientDetails?.gender, setFieldValue]);

                  useEffect(() => {
                    if (!pricingData?.length) return;

                    const selectedRegionsByModality = {};
                    if (values.modality && values.studyRegion) {
                      if (!selectedRegionsByModality[values.modality]) {
                        selectedRegionsByModality[values.modality] = new Set();
                      }
                      selectedRegionsByModality[values.modality].add(values.studyRegion);
                    }

                    values.extraModalities?.forEach((extraModality) => {
                      if (extraModality.modality && extraModality.studyRegion) {
                        if (!selectedRegionsByModality[extraModality.modality]) {
                          selectedRegionsByModality[extraModality.modality] = new Set();
                        }
                        selectedRegionsByModality[extraModality.modality].add(extraModality.studyRegion);
                      }
                    });

                    const allRegionsByModality = {};
                    pricingData.forEach((item) => {
                      if (!allRegionsByModality[item.modality]) {
                        allRegionsByModality[item.modality] = new Set();
                      }
                      allRegionsByModality[item.modality].add(item.studyRegion);
                    });

                    const availableModalities = combinedModalities.filter((modality) => {
                      const allRegions = allRegionsByModality[modality] || new Set();
                      const selectedRegions = selectedRegionsByModality[modality] || new Set();

                      if (allRegions.size === 0 || selectedRegions.size === 0) return true;
                      return allRegions.size > selectedRegions.size;
                    });

                    setFilteredCombinedModalities(availableModalities);
                  }, [values.modality, values.studyRegion, values.extraModalities, pricingData, combinedModalities]);

                  const removeField = (index, { remove }) => {
                    if (remove && typeof remove === 'function') {
                      remove(index);
                      setFields((prevFields) => prevFields.filter((_, i) => i !== index));
                    } else {
                      console.error('remove function is not available');
                    }
                  };

                const handleAppointmentTypeChange = (e) => {
                  const newAppointmentType = e.target.value;
                  setAppointmentType(newAppointmentType);

                  if (appointmentType === "only_investigation" && newAppointmentType !== "only_investigation") {
                    setFieldValue("serviceInvestigation", []);
                    setFieldValue("investigationPrice", "");
                  } else if (appointmentType === 'consultation' && newAppointmentType !== 'consultation') {
                    setFieldValue("price", "");
                    setFieldValue("modality", "");
                    setFieldValue("consultingDoctorName", "");
                  }
                };

                useEffect(() => {
                  if (mode !== 'edit') {
                    setFieldValue('contactNumberCountryCode', selectedCountryCode);
                    setFieldValue('referringDoctorContactNumberCountryCode', selectedCountryCode);
                    setFieldValue('billingPhoneNumberCountryCode', selectedCountryCode);
                    setFieldValue('billingAlternateNumberCountryCode', selectedCountryCode);
                    setFieldValue('billingWhatsappNumberCountryCode', selectedCountryCode);
                  }
                }, [selectedCountryCode, mode]);

                useEffect(() => {
                  if (sameAsHomeAddress) {
                    if (
                      values.billingPhoneNumber &&
                      values.billingWhatsappNumber &&
                      values.billingPhoneNumber === values.billingWhatsappNumber
                    ) {
                      setSameAsPhoneNo(true);
                    } else {
                      setSameAsPhoneNo(false);
                    }
                  } else {
                    if (
                      values.billingPhoneNumber &&
                      values.billingWhatsappNumber &&
                      values.billingPhoneNumber === values.billingWhatsappNumber
                    ) {
                      setSameAsPhoneNo(true);
                    }
                  }
                }, [sameAsHomeAddress, values.billingPhoneNumber, values.billingWhatsappNumber, setSameAsPhoneNo]);

                useEffect(() => {
                  console.log('Initial billingWhatsappNumber:', values.billingWhatsappNumber);
                }, []);

                  return (
                    <Form ref={formRef}>
                      <section className='form__section'>
                          <h1 className="form__section__title">Appointment Form
                            {mode !== "edit" && (
                              <div className="form__radio form__radio--gray">
                                <div className="form__radio__option">
                                  <input type="radio" name="consultation" value="consultation" className="form__radio__input" checked={appointmentType === "consultation"} onChange={handleAppointmentTypeChange} />
                                  <label htmlFor="appointmentType" className="form__radio__label">Consultation</label>
                                </div>
                                <div className="form__radio__option">
                                  <input type="radio" name="investigation_with_modality" value="investigation_with_modality" className="form__radio__input" checked={appointmentType === "investigation_with_modality"} onChange={handleAppointmentTypeChange} />
                                  <label htmlFor="appointmentType" className="form__radio__label">Investigation with Radiology</label>
                                </div>
                                <div className="form__radio__option">
                                  <input type="radio" name="only_investigation" value="only_investigation" className="form__radio__input" checked={appointmentType === "only_investigation"} onChange={handleAppointmentTypeChange} />
                                  <label htmlFor="appointmentType" className="form__radio__label">Only Investigation</label>
                                </div>
                              </div>
                            )}
                          </h1>
                        <div className='formRow formRow__4'>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='contactNumber'>
                                Contact Number<span className="required-asterisk">*</span>
                              </label>
                              <div className='form__groupField form__groupField--phonenumber'>
                                <select
                                  className="form__select form__select--sm"
                                  id="contactNumberCountryCode"
                                  style={customStyle.select}
                                  name="contactNumberCountryCode"
                                  value={values.contactNumberCountryCode}
                                  onChange={handleChange}
                                  disabled={mode === 'edit' || isContactNumberCountryCodeDisabled}
                                >
                                {commonData?.countryCode?.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                  >
                                    {option}
                                  </option>
                                ))}
                                </select>
                                <input
                                  type="text"
                                  className="form__input form__input--sm"
                                  id="contactNumber"
                                  name="contactNumber"
                                  placeholder="Contact Number"
                                  maxLength={10}
                                  onChange={async (e) => {
                                    const numericValue = e.target.value.replace(/\D/g, '');
                                    e.target.value = numericValue;

                                    handleChange(e);

                                    if (numericValue.length === 10) {
                                      setFieldError('contactNumber', '');
                                    }
                                    const valid = phoneNumberRegex.test(numericValue);

                                    if (!valid) {
                                      setFieldValue('UHID', '');
                                      setFieldValue('patientId', '');
                                      setFieldValue('patientName', '');
                                      setFieldValue('contactNumberCountryCode', '');
                                      setPatientList([]);
                                      setIsContactNumberCountryCodeDisabled(false);
                                    } else {
                                      const res = await fetchUserData(numericValue);
                                      if (res) {
                                        setFieldValue('UHID', res?.UHID || '');
                                        setFieldValue('patientId', res?.patientId || '');
                                        setFieldValue('patientName', res?._id || '');
                                        setPatientID(res?._id);
                                        setFieldValue('contactNumberCountryCode', res?.contactNumberCountryCode || defaultCountryCode);
                                        setIsContactNumberCountryCodeDisabled(!!res?.contactNumberCountryCode);
                                      }
                                    }
                                    handleBlur(e);
                                  }}
                                  onBlur={handleBlur}
                                  pattern="[0-9]*"
                                  value={values.contactNumber}
                                  disabled={mode === 'edit'}
                                />
                              </div>
                              <ErrorMessage name="contactNumber" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className='form__Field'>
                              <label className="form__label" htmlFor='UHID' >
                                UHID
                              </label>
                              <input
                                type="text"
                                id="UHID"
                                name="UHID"
                                placeholder="UHID"
                                maxLength={13}
                                onChange={async (e) => {
                                  handleChange(e);
                                  const uhid = e.target.value;
                                  if (!uhid) {
                                    setFieldValue('contactNumber', '');
                                    setFieldValue('patientId', '');
                                    setFieldValue('patientName', '');
                                    setPatientList([]);
                                  } else {
                                    const res = await fetchUserData(uhid);
                                    if (res) {
                                      setFieldValue('contactNumber', getLocalPhoneNumber(res?.contactNumber));
                                      setFieldValue('patientId', res?.patientId || '');
                                      setFieldValue('patientName', res?._id || '');
                                      setFieldError('UHID', '');
                                      setPatientID(res?._id);
                                      setFieldValue('contactNumberCountryCode', res?.contactNumberCountryCode || defaultCountryCode);
                                      setIsContactNumberCountryCodeDisabled(!!res?.contactNumberCountryCode);
                                    } else {
                                      setFieldValue('contactNumber', '');
                                      setFieldValue('patientId', '');
                                      setFieldValue('patientName', '');
                                      setFieldValue('contactNumberCountryCode', '');
                                      setPatientList([]);
                                      setIsContactNumberCountryCodeDisabled(false);
                                    }
                                  }
                                  handleBlur(e);
                                }}
                                onBlur={handleBlur}
                                value={values.UHID}
                                className="form__input form__input--sm"
                              />
                            </div>
                            <ErrorMessage name="UHID" component="div" className="error text-error" />
                          </div>
                          <div className='formCol'>
                            <div className='form__Field'>
                              <label className="form__label" htmlFor='patientName'>
                                Patient Name
                              </label>
                              <select
                                id="patientName"
                                name="patientName"
                                onChange={(e) => {
                                  handleChange(e);
                                  const selectedPatient = patientList.find(patient => patient.id === e.target.value);
                                  if (selectedPatient) {
                                    setFieldValue('UHID', selectedPatient.UHID || '');
                                    setFieldValue('patientId', selectedPatient.patientId || '');
                                    setPatientID(selectedPatient.id);
                                    setPatientDetails(selectedPatient);
                                    setFieldValue('contactNumberCountryCode', selectedPatient.contactNumberCountryCode || defaultCountryCode);
                                    setIsContactNumberCountryCodeDisabled(true);
                                  } else {
                                    setIsContactNumberCountryCodeDisabled(false);
                                  }
                                }}
                                value={values.patientName}
                                className="form__select form__select--sm"
                                style={customStyle.select}
                              >
                                <option value="" disabled>Select Patient</option>
                                {patientList?.map((patient) => (
                                  <option key={patient.id} value={patient.id}>
                                    {capitalizeWords(patient.name)}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <ErrorMessage name='patientName' component='div' className='error text-error' />
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label">
                                Case Study
                                {appointmentType !== 'consultation' && (<span className="required-asterisk">*</span>)}
                              </label>
                              <select
                                className="form__select form__select--sm"
                                id="priority"
                                name="priority"
                                style={customStyle.select}
                                onChange={(e) => {
                                  setFieldValue('priority', e.target.value);
                                }}
                                onBlur={handleBlur}
                                value={values.priority}
                                autoComplete='off'
                                disabled={!isDataAvailable}
                              >
                                <option value="" disabled>-Select-</option>
                                {priorityOptions?.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <ErrorMessage name="priority" component="div" className="error text-error" />
                            </div>
                          </div>
                        </div>
                        <div className='formRow formRow__4'>
                          <div className='formCol'>
                            <div className='form__Field'>
                              <label className="form__label" htmlFor='consultingDoctorName'>
                                Referring Doctor
                              </label>
                              <FormControl fullWidth size="small" variant="outlined">
                                <Autocomplete
                                  freeSolo
                                  disableClearable
                                  options={referringDoctorList}
                                  value={selectedReferringDoctor || ""}
                                  onChange={(event, newValue) => {
                                    const allPackages = [
                                      ...(Array.isArray(getInvestigationData?.result?.data)
                                        ? getInvestigationData.result.data.map((item) => ({
                                          name: item["Package Name"],
                                          price: item.Price,
                                        }))
                                        : []),
                                      ...(Array.isArray(getBillingPackageData?.result?.data)
                                        ? getBillingPackageData?.result?.data.map((item) => ({
                                          name: item.packageName,
                                          price: item.packagePricing,
                                        }))
                                        : []),
                                    ];

                                    const selectedPackages = values.serviceInvestigation.map((name) =>
                                      allPackages.find((pkg) => pkg.name === name)
                                    ).filter(Boolean);

                                    const prices = selectedPackages.map((pkg) => pkg.price).join(", ");
                                    if (newValue === null) {
                                      setReferringDoctorData({});
                                      setSelectedReferringDoctor('');
                                      setFieldValue("referringDoctor", '');
                                      return;
                                    } else {
                                      const referringDoctorData = referringDoctorDiscountList.find((doctor) => doctor.doctorName === newValue);
                                      if (!referringDoctorData) return;
                                      if (values.investigationPrice && values.investigationPrice.length > 0) {
                                        let discountedPrice;
                                        if (referringDoctorData?.investigationDiscount === "--" || referringDoctorData?.investigationDiscount === "") {
                                          discountedPrice = modifyPrices(prices, 0, +referringDoctorData?.investigationHikePrice);
                                        } else {
                                          discountedPrice = modifyPrices(prices, +referringDoctorData?.investigationDiscount, 0);
                                        }
                                        setFieldValue("investigationPrice", discountedPrice);
                                      }
                                      setSelectedReferringDoctor(newValue);
                                      setReferringDoctorData(referringDoctorData);
                                      setFieldValue("referringDoctor", newValue);
                                    }

                                    if (values.modality && values.studyRegion) {
                                      const mainPrice = calculatePrice(values.modality, values.studyRegion, values.referringDoctor);
                                      if (mainPrice !== undefined) {
                                        if (newValue !== "" || newValue !== null) {
                                          // const referringDoctorData = referringDoctorDiscountList.find((doctor) => doctor.doctorName === newValue);
                                          // let discountedPrice = modifyModalityStudyPrices(mainPrice, values.modality, values.studyRegion, referringDoctorData);
                                          // setFieldValue("price", discountedPrice);
                                        } else {
                                          setFieldValue("price", mainPrice);
                                        }
                                      }
                                    }

                                    values.extraModalities?.forEach((extraModality, index) => {
                                      if (extraModality.modality && extraModality.studyRegion) {
                                        const extraPrice = calculatePrice(
                                          extraModality.modality,
                                          extraModality.studyRegion,
                                          values.referringDoctor
                                        );
                                        if (extraPrice !== undefined) {
                                      // let extraDiscountedPrice = modifyModalityStudyPrices(extraPrice, extraModality.modality, extraModality.studyRegion, referringDoctorData);
                                      // setFieldValue(`extraModalities[${index}].price`, extraDiscountedPrice.toString());
                                        } else {
                                          setFieldValue(`extraModalities[${index}].price`, extraPrice.toString());
                                        }
                                      }
                                    });
                                  }}

                                  onInputChange={(event, newInputValue) => {
                                    const allPackages = [
                                      ...(Array.isArray(getInvestigationData?.result?.data)
                                        ? getInvestigationData.result.data.map((item) => ({
                                          name: item["Package Name"],
                                          price: item.Price,
                                        }))
                                        : []),
                                      ...(Array.isArray(getBillingPackageData?.result?.data)
                                        ? getBillingPackageData?.result?.data.map((item) => ({
                                          name: item.packageName,
                                          price: item.packagePricing,
                                        }))
                                        : []),
                                    ];

                                    const selectedPackages = values.serviceInvestigation.map((name) =>
                                      allPackages.find((pkg) => pkg.name === name)
                                    ).filter(Boolean);

                                    const prices = selectedPackages.map((pkg) => pkg.price).join(", ");

                                    const exactMatch = referringDoctorList.find((doctor) =>
                                      doctor.toLowerCase() === newInputValue.toLowerCase()
                                    );
                                    if (exactMatch) {

                                      const referringDoctorData = referringDoctorDiscountList.find((doctor) =>
                                        doctor.doctorName.toLowerCase() === exactMatch.toLowerCase()
                                      );
                                      if (values.modality && values.studyRegion) {
                                        const mainPrice = calculatePrice(values.modality, values.studyRegion, values.referringDoctor);
                                        if (mainPrice !== undefined) {
                                          if (newInputValue !== "" || newInputValue !== null) {
                                            let discountedPrice = modifyModalityStudyPrices(mainPrice, values.modality, values.studyRegion, referringDoctorData);
                                            setFieldValue("price", discountedPrice);
                                          } else {
                                            setFieldValue("price", mainPrice);
                                          }
                                        }
                                      }

                                      values.extraModalities?.forEach((extraModality, index) => {
                                        if (extraModality.modality && extraModality.studyRegion) {
                                          const extraPrice = calculatePrice(
                                            extraModality.modality,
                                            extraModality.studyRegion,
                                            values.referringDoctor
                                          );
                                          if (extraPrice !== undefined) {
                                            let extraDiscountedPrice = modifyModalityStudyPrices(extraPrice, extraModality.modality, extraModality.studyRegion, referringDoctorData);
                                            setFieldValue(`extraModalities[${index}].price`, extraDiscountedPrice.toString());
                                          } else {
                                            setFieldValue(`extraModalities[${index}].price`, extraPrice.toString());
                                          }
                                        }
                                      });

                                      let discountedPrice;
                                      if (referringDoctorData?.investigationDiscount === "--" || referringDoctorData?.investigationDiscount == "") {
                                        discountedPrice = modifyPrices(prices, 0, +referringDoctorData?.investigationHikePrice);
                                      } else {
                                        discountedPrice = modifyPrices(prices, +referringDoctorData?.investigationDiscount, 0);
                                      }

                                      setFieldValue("investigationPrice", discountedPrice);
                                      setReferringDoctorData(referringDoctorData);
                                    } else {
                                      setFieldValue("investigationPrice", prices);
                                      setReferringDoctorData({});
                                    }
                                    setSelectedReferringDoctor(newInputValue);
                                    setFieldValue("referringDoctor", newInputValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder={"-Select-"}
                                      size="small"
                                      fullWidth
                                      style={customStyle.select}
                                      InputProps={{
                                        ...params.InputProps,
                                        style: {
                                          color: "black",
                                          fontFamily: "'Quicksand', sans-serif",
                                          fontSize: "14px",
                                          padding: "9px",
                                          cursor: "pointer",
                                          borderRadius: '2rem',
                                        },
                                      }}
                                      sx={{
                                        "& .MuiInputBase-input::placeholder": {
                                          color: "black",
                                          opacity: 1,
                                        },
                                        "& .MuiOutlinedInput-root": {
                                          "&.Mui-focused fieldset": {
                                            borderColor: "black",
                                          },
                                          "&:hover fieldset": {
                                            borderColor: "black",
                                          },
                                        },
                                      }}
                                      className="form__select form__select--sm"
                                    />
                                  )}
                                />
                              </FormControl>
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='referringDoctorSpeciality'>
                                Referring Doctor Speciality
                              </label>
                              <input
                                className="form__input form__input--sm"
                                type="text"
                                id="referringDoctorSpeciality"
                                name="referringDoctorSpeciality"
                                placeholder="Referring Doctor Speciality"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
                                  handleChange({
                                    target: {
                                      name: 'referringDoctorSpeciality',
                                      value: filteredValue,
                                    },
                                  });
                                }}
                                onBlur={handleBlur}
                                value={values.referringDoctorSpeciality}
                                autoComplete='off'
                                disabled={!isDataAvailable}
                              />
                              {touched.referringDoctorSpeciality && errors.referringDoctorSpeciality && (
                                <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                  {errors.referringDoctorSpeciality}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='referringDoctorContactNumberCountryCode'>
                                Referring Doctor Contact Number
                              </label>
                              <div className='form__groupField form__groupField--phonenumber'>
                                <select className="form__select form__select--sm"
                                  style={customStyle.select}
                                  id="referringDoctorContactNumberCountryCode"
                                  name="referringDoctorContactNumberCountryCode"
                                  value={values.referringDoctorContactNumberCountryCode}
                                  onChange={handleChange}
                                  disabled={!isDataAvailable}
                                >
                                  {commonData?.countryCode?.map((option) => (
                                    <option
                                      key={option}
                                      value={option}
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <input type="text"
                                  className="form__input form__input--sm"
                                  id="referringDoctorContactNumber"
                                  name="referringDoctorContactNumber"
                                  placeholder="Contact Number"
                                  maxLength={10}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange(e);
                                  }}
                                  pattern="[0-9]*"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.referringDoctorContactNumber}
                                  disabled={!isDataAvailable}
                                >
                                </input>
                              </div>
                              <ErrorMessage name="referringDoctorContactNumber" component="div" className="error text-error" />
                            </div>
                          </div>
                             {/* Consultation-specific fields */}
                          {appointmentType === 'consultation' && (
                             <div className='formCol'>
                             <div className="form__Field">
                               <label className="form__label">
                               Consulting Doctor<span className="required-asterisk">*</span>
                               </label>
                               <select
                                name="consultingDoctorName"
                                id="consultingDoctorName"
                                 className="form__select form__select--sm"
                                 style={customStyle.select}
                                 value={values.consultingDoctorName}
                                 onChange={(e) => {
                                   const radiologistName = e.target.value;
                                   handleChange(e)
                                  setFieldValue("price", "");
                                   setFieldValue("modality", "");
                                 }}
                                 disabled={!isDataAvailable}
                               >
                                 <option value="">-Select Doctor-</option>
                                 {getConsultationChargesData?.charges?.map((charge) => (
                                   <option key={charge.radiologistId} value={charge.radiologistName}>
                                     {charge.radiologistName}
                                   </option>
                                 ))}
                               </select>
                               <ErrorMessage name="consultingDoctorName" component="div" className="error text-error" />
                             </div>
                           </div>
                          )}



                        {appointmentType !== "consultation" && (
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='consultingDoctorName'>
                                Consulting Doctor
                              </label>
                              <input
                                className="form__input form__input--sm"
                                type="text"
                                id="consultingDoctorName"
                                name="consultingDoctorName"
                                placeholder="Consulting Doctor Name"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
                                  handleChange({
                                    target: {
                                      name: 'consultingDoctorName',
                                      value: filteredValue,
                                    },
                                  });
                                }}
                                onBlur={handleBlur}
                                value={values.consultingDoctorName}
                                autoComplete='off'
                                disabled={!isDataAvailable}
                              />
                              {touched.consultingDoctorName && errors.consultingDoctorName && (
                                <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                  {errors.consultingDoctorName}
                                </div>
                              )}
                            </div>
                        </div>
                        )}
                        </div>
                        {appointmentType === "investigation_with_modality" && (
                          <>
                            <div className="formRow formRow__2">
                              <div className='formCol'>
                                <div className='formRow formRow__3'>
                                  <div className="formCol">
                                    <div className="form__Field">
                                      <label className="form__label">
                                        Modality<span className="required-asterisk">*</span>
                                        <FieldArray name="extraModalities">
                                          {({ push }) => (
                                            <button type="button" className="text-lg text-[#51A196] ml-2" onClick={() => addMoreFields({ push })}>
                                              + Add more
                                            </button>
                                          )}
                                        </FieldArray>
                                      </label>
                                      <Autocomplete
                                        id="modality"
                                        options={filteredCombinedModalities}
                                        getOptionLabel={(option) => option || ""}
                                        value={values.modality || null}
                                        onChange={(event, newValue) => {
                                          setFieldValue('modality', newValue);
                                          setModalityData(newValue);
                                          handleModalityChange(newValue, null, values, setFieldValue);
                                        }}
                                        onBlur={handleBlur}
                                        style={{ ...customStyle.select, borderRadius: '2rem' }}
                                        disabled={!isDataAvailable}
                                        popupIcon={null}
                                        clearIcon={null}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="-Select-"
                                            size="small"
                                            fullWidth
                                            InputProps={{
                                              ...params.InputProps,
                                              style: {
                                                color: "black",
                                                fontFamily: "'Quicksand', sans-serif",
                                                fontSize: "14px",
                                                padding: "9px",
                                                cursor: "pointer",
                                                borderRadius: '2rem'
                                              },
                                            }}
                                            sx={{
                                              "& .MuiInputBase-input::placeholder": {
                                                color: "black",
                                                opacity: 1,
                                              },
                                              "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                  borderColor: "black",
                                                },
                                                "&:hover fieldset": {
                                                  borderColor: "black",
                                                },
                                              },
                                            }}
                                            className="form__select form__select--sm"
                                          />
                                        )}
                                      />
                                      <ErrorMessage name="modality" component="div" className="error text-error" />
                                    </div>
                                  </div>
                                  <div className="formCol">
                                    <div className="form__Field">
                                      <label className="form__label">
                                        Study Region<span className="required-asterisk">*</span>
                                      </label>
                                      <select
                                        className="form__select form__select--sm"
                                        id="studyRegion"
                                        name="studyRegion"
                                        style={customStyle.select}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          handleChange(e);
                                          if (value) {
                                            setFieldValue("price", "");
                                          }
                                        }}
                                        onBlur={handleBlur}
                                        value={values.studyRegion || ""}
                                        autoComplete="off"
                                        disabled={!isDataAvailable || !values.modality}
                                      >
                                        <option value="" disabled>-Select-</option>
                                        {getAvailableStudyRegions(values.modality, values, null).map((option, index) => (
                                          <option key={index} value={option}>
                                            {option}
                                          </option>
                                        ))}
                                      </select>
                                      <ErrorMessage name="studyRegion" component="div" className="error text-error" />
                                    </div>
                                  </div>
                                  <div className="formCol">
                                    <div className="form__Field">
                                      <label className="form__label">
                                        Machine Name<span className="required-asterisk">*</span>
                                      </label>
                                      <select
                                        id="machineName"
                                        name="machineName"
                                        className="form__select form__select--sm"
                                        style={customStyle.select}
                                        value={values.machineName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        autoComplete="off"
                                        disabled={!isDataAvailable || !values.modality}
                                      >
                                        <option value="" disabled>-Select-</option>
                                        {machineList?.length > 0 &&
                                          machineList
                                            .filter((machineGroup) => machineGroup.machineType === values.modality)
                                            .flatMap((machineGroup) => machineGroup.machines || [])
                                            .filter((machine) => machine.status === "enabled")
                                            .map((machine, idx) => (
                                              <option key={idx} value={machine.machineName}>
                                                {machine.machineName}
                                              </option>
                                            ))}
                                      </select>
                                      <ErrorMessage name="machineName" component="div" className="error text-error" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='formCol'>
                              <div className='formRow formRow__3'>
                                <div className='formCol'>
                                  <div className='form__Field'>
                                    <label className="form__label" htmlFor='price'>
                                      Price<span className='required-asterisk'>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      disabled
                                      id="price"
                                      name="price"
                                      placeholder="Price"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.price}
                                      className="form__input form__input--sm disabled-input"
                                    />
                                  </div>
                                  <ErrorMessage name="price" component="div" className="error text-error" />
                                </div>
                                <div className='formCol'>
                                  <div className="form__Field">
                                    <label className="form__label">
                                      Appointment Date<span className="required-asterisk">*</span>
                                    </label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <Field name="date" style={{ width: '100%' }}>
                                        {({ field }) => (
                                          <DatePicker
                                            sx={{
                                              width: '100%',
                                              '& .MuiInputBase-root': {
                                                backgroundColor: '#F6FFFF',
                                                borderRadius: '2rem'
                                              },
                                              '& .MuiInputBase-input': {
                                                padding: '10px',
                                              },
                                            }}
                                            {...field}
                                            value={field.value || null}
                                            format="DD/MM/YYYY"
                                            disabled={!isDataAvailable}
                                            onChange={(newValue) => {
                                              setFieldValue(field.name, newValue);
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                error={touched.date && Boolean(errors.date)}
                                                helperText={touched.date && errors.date}
                                              />
                                            )}
                                          />
                                        )}
                                      </Field>
                                    </LocalizationProvider>
                                    <ErrorMessage name="date" component="div" className="error text-error" />
                                  </div>
                                </div>
                                <div className='formCol'>
                                  <div className="form__Field">
                                    <label className="form__label">
                                      Appointment Time<span className="required-asterisk">*</span>
                                    </label>
                                    <select
                                      className="form__select form__select--sm"
                                      id="time"
                                      name="time"
                                      style={customStyle.select}
                                      onChange={(e) => {
                                        setFieldValue('time', e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      value={values.time}
                                      autoComplete='off'
                                      disabled={!isDataAvailable}
                                    >
                                      <option value="" disabled>-Select-</option>
                                      {timeSlot?.map((option) => (
                                        <option key={option.value} value={option.value}>
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                    <ErrorMessage name="time" component="div" className="error text-error" />
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {values.extraModalities?.length > 0 && (
                              <div className="mt-6 border-t pt-4">
                                <FieldArray name="extraModalities">
                                  {({ remove, push }) => (
                                    <>
                                      {values.extraModalities.map((field, index) => (
                                        <div key={fields[index]?.id || index} className="mb-6 pb-4 border-b">
                                          <div className="formRow formRow__2">
                                            <div className='formCol'>
                                              <div className='formRow formRow__3'>
                                                <div className="formCol">
                                                  <div className="form__Field">
                                                    <label className="form__label">
                                                      Modality<span className="required-asterisk">*</span>
                                                      <button
                                                        type="button"
                                                        className="text-lg text-red-600 ml-2"
                                                        onClick={() => removeField(index, { remove })}
                                                      >
                                                        Remove
                                                      </button>
                                                    </label>
                                                    <Autocomplete
                                                      id={`extraModalities[${index}].modality`}
                                                      options={filteredCombinedModalities}
                                                      getOptionLabel={(option) => option || ""}
                                                      value={values.extraModalities[index]?.modality || null}
                                                      onChange={(event, newValue) => {
                                                        handleModalityChange(newValue, index, values, setFieldValue);
                                                      }}
                                                      onBlur={handleBlur}
                                                      style={{ ...customStyle.select, borderRadius: '2rem' }}
                                                      disabled={!isDataAvailable}
                                                      popupIcon={null}
                                                      clearIcon={null}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                          placeholder="-Select-"
                                                          size="small"
                                                          fullWidth
                                                          InputProps={{
                                                            ...params.InputProps,
                                                            style: {
                                                              color: "black",
                                                              fontFamily: "'Quicksand', sans-serif",
                                                              fontSize: "14px",
                                                              padding: "9px",
                                                              cursor: "pointer",
                                                              borderRadius: '2rem'
                                                            },
                                                          }}
                                                          sx={{
                                                            "& .MuiInputBase-input::placeholder": {
                                                              color: "black",
                                                              opacity: 1,
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                              "&.Mui-focused fieldset": {
                                                                borderColor: "black",
                                                              },
                                                              "&:hover fieldset": {
                                                                borderColor: "black",
                                                              },
                                                            },
                                                          }}
                                                          className="form__select form__select--sm"
                                                        />
                                                      )}
                                                    />
                                                    <ErrorMessage
                                                      name={`extraModalities[${index}].modality`}
                                                      component="div"
                                                      className="error text-error"
                                                    />
                                                  </div>
                                                </div>
                                                <div className="formCol">
                                                  <div className="form__Field">
                                                    <label className="form__label">
                                                      Study Region<span className="required-asterisk">*</span>
                                                    </label>
                                                    <select
                                                      className="form__select form__select--sm"
                                                      id={`extraModalities[${index}].studyRegion`}
                                                      name={`extraModalities[${index}].studyRegion`}
                                                      style={customStyle.select}
                                                      onChange={(e) => {
                                                        handleChange(e);
                                                        if (e.target.value) {
                                                          setFieldValue(`extraModalities[${index}].price`, "");
                                                        }
                                                      }}
                                                      onBlur={handleBlur}
                                                      value={values.extraModalities[index]?.studyRegion || ""}
                                                      autoComplete="off"
                                                      disabled={!isDataAvailable || !values.extraModalities[index]?.modality}
                                                    >
                                                      <option value="" disabled>-Select-</option>
                                                      {getAvailableStudyRegions(values.extraModalities[index]?.modality, values, index).map(
                                                        (option, idx) => (
                                                          <option key={idx} value={option}>
                                                            {option}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                    <ErrorMessage
                                                      name={`extraModalities[${index}].studyRegion`}
                                                      component="div"
                                                      className="error text-error"
                                                    />
                                                  </div>
                                                </div>
                                                <div className="formCol">
                                                  <div className="form__Field">
                                                    <label className="form__label">
                                                      Machine Name<span className="required-asterisk">*</span>
                                                    </label>
                                                    <select
                                                      className="form__select form__select--sm"
                                                      id={`extraModalities[${index}].machineName`}
                                                      name={`extraModalities[${index}].machineName`}
                                                      style={customStyle.select}
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                      value={values.extraModalities[index]?.machineName || ""}
                                                      autoComplete="off"
                                                      disabled={!isDataAvailable || !values.extraModalities[index]?.modality}
                                                    >
                                                      <option value="" disabled>-Select-</option>
                                                      {machineList?.length > 0 &&
                                                        machineList
                                                          .filter((machineGroup) => machineGroup.machineType === values.extraModalities[index]?.modality)
                                                          .flatMap((machineGroup) => machineGroup.machines || [])
                                                          .filter((machine) => machine.status === "enabled")
                                                          .map((machine, idx) => (
                                                            <option key={idx} value={machine.machineName}>
                                                              {machine.machineName}
                                                            </option>
                                                          ))}
                                                    </select>
                                                    <ErrorMessage
                                                      name={`extraModalities[${index}].machineName`}
                                                      component="div"
                                                      className="error text-error"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className='formRow formRow__3'>
                                              <div className='formCol'>
                                                <div className='form__Field'>
                                                  <label className="form__label" htmlFor={`extraModalities[${index}].price`}>
                                                    Price<span className='required-asterisk'>*</span>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    disabled
                                                    id={`extraModalities[${index}].price`}
                                                    name={`extraModalities[${index}].price`}
                                                    placeholder="Price"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.extraModalities[index]?.price || ""}
                                                    className="form__input form__input--sm disabled-input"
                                                  />
                                                  <ErrorMessage
                                                    name={`extraModalities[${index}].price`}
                                                    component="div"
                                                    className="error text-error"
                                                  />
                                                </div>
                                              </div>
                                              <div className='formCol'>
                                                <div className="form__Field">
                                                  <label className="form__label">
                                                    Appointment Date<span className="required-asterisk">*</span>
                                                  </label>
                                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Field name={`extraModalities[${index}].date`} style={{ width: '100%' }}>
                                                      {({ field }) => (
                                                        <DatePicker
                                                          sx={{
                                                            width: '100%',
                                                            '& .MuiInputBase-root': {
                                                              backgroundColor: '#F6FFFF',
                                                              borderRadius: '2rem'
                                                            },
                                                            '& .MuiInputBase-input': {
                                                              padding: '10px',
                                                            },
                                                          }}
                                                          {...field}
                                                          value={field.value || null}
                                                          format="DD/MM/YYYY"
                                                          disabled={!isDataAvailable}
                                                          onChange={(newValue) => {
                                                            setFieldValue(field.name, newValue);
                                                          }}
                                                          renderInput={(params) => (
                                                            <TextField
                                                              {...params}
                                                              error={touched.extraModalities?.[index]?.date && Boolean(errors.extraModalities?.[index]?.date)}
                                                              helperText={touched.extraModalities?.[index]?.date && errors.extraModalities?.[index]?.date}
                                                            />
                                                          )}
                                                        />
                                                      )}
                                                    </Field>
                                                  </LocalizationProvider>
                                                  <ErrorMessage
                                                    name={`extraModalities[${index}].date`}
                                                    component="div"
                                                    className="error text-error"
                                                  />
                                                </div>
                                              </div>
                                              <div className='formCol'>
                                                <div className="form__Field">
                                                  <label className="form__label">
                                                    Appointment Time<span className="required-asterisk">*</span>
                                                  </label>
                                                  <select
                                                    className="form__select form__select--sm"
                                                    id={`extraModalities[${index}].time`}
                                                    name={`extraModalities[${index}].time`}
                                                    style={customStyle.select}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.extraModalities[index]?.time || ""}
                                                    autoComplete='off'
                                                    disabled={!isDataAvailable}
                                                  >
                                                    <option value="" disabled>-Select-</option>
                                                    {timeSlot?.map((option) => (
                                                      <option key={option.value} value={option.value}>
                                                        {option.label}
                                                      </option>
                                                    ))}
                                                  </select>
                                                  <ErrorMessage
                                                    name={`extraModalities[${index}].time`}
                                                    component="div"
                                                    className="error text-error"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </FieldArray>
                              </div>
                            )}
                          </>
                        )}
                        {appointmentType === "consultation" && (
                          <div className='formRow formRow__4'>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label">
                                  Consultation Services<span className="required-asterisk">*</span>
                                </label>
                                <select
                                  className="form__select form__select--sm"
                                  style={customStyle.select}
                                  value={values.modality || ""}
                                  onChange={(e) => {
                                    handleChange(e);

                                  }}
                                  id='modality'
                                  name='modality'
                                  disabled={!values?.consultingDoctorName || !isDataAvailable}
                                >
                                  <option value="" disabled>-Select-</option>
                                  {getModalitiesForRadiologist(values?.consultingDoctorName).map((modality) => (
                                    <option key={modality} value={modality}>
                                      {modality}
                                    </option>
                                  ))}
                                </select>
                              </div>
                          </div>
                          <div className='formCol'>
                          <div className='form__Field'>
                                <label className="form__label" htmlFor='price'>
                                  Price<span className='required-asterisk'>*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  id="price"
                                  name="price"
                                  placeholder="Price"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.price}
                                  className="form__input form__input--sm disabled-input"

                                />
                                <ErrorMessage name="price" component="div" className="error text-error" />
                              </div>

                            </div>
                            <div className='formCol'>
                                  <div className="form__Field">
                                    <label className="form__label">
                                      Appointment Date<span className="required-asterisk">*</span>
                                    </label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <Field name="date" style={{ width: '100%' }}>
                                        {({ field }) => (
                                          <DatePicker
                                            sx={{
                                              width: '100%',
                                              '& .MuiInputBase-root': {
                                                backgroundColor: '#F6FFFF',
                                                borderRadius: '2rem'
                                              },
                                              '& .MuiInputBase-input': {
                                                padding: '10px',
                                              },
                                            }}
                                            {...field}
                                            value={field.value || null}
                                            format="DD/MM/YYYY"
                                            disabled={!isDataAvailable}
                                            onChange={(newValue) => {
                                              setFieldValue(field.name, newValue);
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                error={touched.date && Boolean(errors.date)}
                                                helperText={touched.date && errors.date}
                                              />
                                            )}
                                          />
                                        )}
                                      </Field>
                                    </LocalizationProvider>
                                    <ErrorMessage name="date" component="div" className="error text-error" />
                                  </div>
                                </div>
                                <div className='formCol'>
                                  <div className="form__Field">
                                    <label className="form__label">
                                      Appointment Time<span className="required-asterisk">*</span>
                                    </label>
                                    <select
                                      className="form__select form__select--sm"
                                      id="time"
                                      name="time"
                                      style={customStyle.select}
                                      onChange={(e) => {
                                        setFieldValue('time', e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      value={values.time}
                                      autoComplete='off'
                                      disabled={!isDataAvailable}
                                    >
                                      <option value="" disabled>-Select-</option>
                                      {commonData?.consultationTimeslots?.map((option) => (
                                        <option key={option.value} value={option.value}>
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                    <ErrorMessage name="time" component="div" className="error text-error" />
                                  </div>
                                  </div>
                             </div>
                        )}

                      {appointmentType !== "consultation" && (
                            <div className='formRow formRow__2'>
                              <div className="formCol">
                                <div className="form__Field">
                                  <label className="form__label">Service Investigation
                                    {appointmentType === 'only_investigation' && <span className="required-asterisk">*</span>}
                                  </label>
                                  <Autocomplete
                                    id="serviceInvestigation"
                                    multiple
                                    options={sortOptions(investigationOptions || [])}
                                    getOptionLabel={(option) => option || ""}
                                    value={values.serviceInvestigation || []}
                                    onChange={(event, newValues) => {
                                      const allPackages = [
                                        ...(Array.isArray(getInvestigationData?.result?.data)
                                          ? getInvestigationData.result.data.map((item) => ({
                                            name: item["Package Name"],
                                            price: item.Price,
                                          }))
                                          : []),
                                        ...(Array.isArray(getBillingPackageData?.result?.data)
                                          ? getBillingPackageData?.result?.data.map((item) => ({
                                            name: item.packageName,
                                            price: item.packagePricing,
                                          }))
                                          : []),
                                      ];

                                      const selectedPackages = newValues.map((name) =>
                                        allPackages.find((pkg) => pkg.name === name)
                                      ).filter(Boolean);

                                      const prices = selectedPackages.map((pkg) => pkg.price).join(", ");

                                      if (Object.keys(referringDoctorData).length === 0) {
                                        setFieldValue("investigationPrice", prices);
                                      } else {
                                        let discountedPrice;
                                        if (referringDoctorData?.investigationDiscount === "--") {
                                          discountedPrice = modifyPrices(prices, 0, +referringDoctorData?.investigationHikePrice);
                                      } else {
                                        discountedPrice = modifyPrices(prices, +referringDoctorData?.investigationDiscount, 0);
                                      }
                                      setFieldValue("investigationPrice", discountedPrice);
                                    }
                                    setFieldValue("serviceInvestigation", newValues);
                                  }}
                                  onBlur={(event) => {
                                    handleBlur(event);
                                  }}
                                  style={{ ...customStyle.select, borderRadius: '2rem' }}
                                  disabled={!isDataAvailable}
                                  popupIcon={null}
                                  clearIcon={null}
                                  open={isOpen}
                                  onOpen={() => setIsOpen(true)}
                                  onClose={(event, reason) => {
                                    if (reason === "blur" || reason === "toggleInput") {
                                      setIsOpen(false);
                                    }
                                  }}
                                  renderTags={(value, getTagProps) => {
                                    const maxDisplayedTags = 1;
                                    const displayedTags = value.slice(0, maxDisplayedTags);
                                    const remainingTags = value.slice(maxDisplayedTags);
                                    const remainingTagsCount = remainingTags.length;

                                    return [
                                      ...displayedTags.map((option, index) => (
                                        <Chip
                                          key={index}
                                          label={option}
                                          {...getTagProps({ index })}
                                          style={{
                                            fontFamily: "'Quicksand', sans-serif",
                                            fontSize: "14px",
                                            backgroundColor: "#e0e0e0",
                                            margin: "2px",
                                          }}
                                        />
                                      )),
                                      remainingTagsCount > 0 && (
                                        <Tooltip
                                          title={
                                            <div>
                                              {remainingTags.map((item, idx) => (
                                                <div key={idx}>{item}</div>
                                              ))}
                                            </div>
                                          }
                                          arrow
                                          placement="top"
                                        >
                                          <Chip
                                            label={`+${remainingTagsCount}...`}
                                            style={{
                                              fontFamily: "'Quicksand', sans-serif",
                                              fontSize: "14px",
                                              backgroundColor: "#e0e0e0",
                                              margin: "2px",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </Tooltip>
                                      ),
                                    ];
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                      <span>{option}</span>
                                      <SortIcon
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
                                        }}
                                        style={{ cursor: 'pointer', fontSize: '18px' }}
                                      />
                                    </li>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder={
                                        values.serviceInvestigation && values.serviceInvestigation.length > 0
                                          ? ""
                                          : "-Select-"
                                      }
                                      size="small"
                                      fullWidth
                                      InputProps={{
                                        ...params.InputProps,
                                        style: {
                                          color: "black",
                                          fontFamily: "'Quicksand', sans-serif",
                                          fontSize: "14px",
                                          padding:
                                            values.serviceInvestigation && values.serviceInvestigation.length > 0
                                              ? "3px"
                                              : "9px",
                                          cursor: "pointer",
                                          borderRadius: '2rem',
                                        },
                                      }}
                                      sx={{
                                        "& .MuiInputBase-input::placeholder": {
                                          color: "black",
                                          opacity: 1,
                                        },
                                        "& .MuiOutlinedInput-root": {
                                          "&.Mui-focused fieldset": {
                                            borderColor: "black",
                                          },
                                          "&:hover fieldset": {
                                            borderColor: "black",
                                          },
                                        },
                                      }}
                                      className="form__select form__select--sm"
                                    />
                                  )}
                                />
                                <ErrorMessage name="serviceInvestigation" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='investigationPrice'>
                                  Investigation Price
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  id="investigationPrice"
                                  name="investigationPrice"
                                  placeholder="Investigation Price"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.investigationPrice || ""}
                                  className="form__input form__input--sm disabled-input"
                                />
                                <ErrorMessage name="investigationPrice" component="div" className="error text-error" />
                              </div>
                            </div>
                          </div>
                        )}
                      </section>
                      <section className='form__section'>
                        <h1 className='form__section__title'>Billing Information</h1>
                        <div className='formRow formRow__full'>
                          <div className='formCol'>
                            <div className="form__Field">
                              <div className="form__checkboxSubField">
                                <div className="form__checkbox">
                                  <div className="form__checkbox__option m_0">
                                    <input
                                      className="form__checkbox__input"
                                      disabled={!isDataAvailable}
                                      id='sameAsHomeAddress'
                                      checked={sameAsHomeAddress}
                                      type="checkbox"
                                      name="sameAsHomeAddress"
                                      value="sameAsHomeAddress"
                                      onChange={(e) => {
                                        const newValue = !sameAsHomeAddress;
                                        setSameAsHomeAddress(newValue);
                                        if (newValue) {
                                          setFieldValue('addressLine1', patientDetails?.billingInfo?.addressLine1 || '');
                                          setFieldValue('billingZipCode', patientDetails?.billingInfo?.zipCode || '');
                                          setFieldValue('billingCity', patientDetails?.billingInfo?.city || '');
                                          setFieldValue('billingState', patientDetails?.billingInfo?.state || '');
                                          setFieldValue('billingCountry', patientDetails?.billingInfo?.country || '');
                                          setFieldValue('billingPhoneNumber', patientDetails?.billingInfo?.mobileNo || '');
                                          setFieldValue('billingPhoneNumberCountryCode', patientDetails?.billingInfo?.dialCode || '+91');
                                          setFieldValue('billingWhatsappNumber', patientDetails?.billingInfo?.whatsappNo || '');
                                          setFieldValue('billingWhatsappNumberCountryCode', patientDetails?.billingInfo?.whatsappNoDialCode || '+91');
                                          setFieldValue('billingAlternateNumber', patientDetails?.billingInfo?.alternateNo || '');
                                          setFieldValue('billingAlternateNumberCountryCode', patientDetails?.billingInfo?.alternateNoDialCode || '+91');
                                        } else {
                                          setFieldValue('addressLine1', '');
                                          setFieldValue('billingZipCode', '');
                                          setFieldValue('billingCity', '');
                                          setFieldValue('billingState', '');
                                          setFieldValue('billingCountry', '');
                                          setFieldValue('billingPhoneNumber', '');
                                          setFieldValue('billingPhoneNumberCountryCode', selectedCountryCode);
                                          setFieldValue('billingWhatsappNumber', '');
                                          setFieldValue('billingWhatsappNumberCountryCode', selectedCountryCode);
                                          setFieldValue('billingAlternateNumber', '');
                                          setFieldValue('billingAlternateNumberCountryCode', selectedCountryCode);
                                          setSameAsPhoneNo(false);
                                        }
                                      }}
                                    />
                                    <label htmlFor="sameAsHomeAddress" className="form__checkbox__label"> Same as Home Address</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='formRow formRow__4'>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='billingName'>Billing Name<span className="required-asterisk">*</span></label>
                              <input
                                className="form__input form__input--sm"
                                type="text"
                                id="billingName"
                                name="billingName"
                                placeholder="Billing Name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.billingName}
                                disabled={!isDataAvailable}
                              />
                              <ErrorMessage name="billingName" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='addressLine1'>Billing Address<span className="required-asterisk">*</span></label>
                              <input
                                className="form__input form__input--sm"
                                type="text"
                                id="addressLine1"
                                name="addressLine1"
                                placeholder="Billing Address"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={sameAsHomeAddress || !isDataAvailable}
                                value={sameAsHomeAddress ? values.addressLine1 = patientDetails?.billingInfo?.addressLine1 : values.addressLine1}
                              />
                              <ErrorMessage name="addressLine1" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='billingPhoneNumberCountryCode'>
                                Contact Number
                              </label>
                              <div className='form__groupField form__groupField--phonenumber'>
                                <select
                                  className="form__select form__select--sm"
                                  style={customStyle.select}
                                  id="billingPhoneNumberCountryCode"
                                  onChange={(e) => {
                                    setFieldValue('billingPhoneNumberCountryCode', e.target.value);
                                    if (sameAsPhoneNo) {
                                      setFieldValue('billingWhatsappNumberCountryCode', e.target.value);
                                    }
                                  }}
                                  disabled={sameAsHomeAddress || !isDataAvailable}
                                  value={values.billingPhoneNumberCountryCode}
                                >
                                {commonData?.countryCode?.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                  >
                                    {option}
                                  </option>
                                ))}
                                </select>
                                <input
                                  type="text"
                                  className="form__input form__input--sm"
                                  id="billingPhoneNumber"
                                  name="billingPhoneNumber"
                                  placeholder="Contact Number"
                                  maxLength={10}
                                  onKeyDown={(event) => {
                                    if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'Tab') {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={sameAsHomeAddress || !isDataAvailable}
                                  value={sameAsHomeAddress ? getLocalPhoneNumber(patientDetails?.billingInfo?.mobileNo) : values.billingPhoneNumber}
                                />
                              </div>
                            </div>
                          </div>

                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='whatsappNumber'>Whatsapp Number</label>
                              <div className="form__groupField form__groupField--phonenumber">
                                <select
                                  className="form__select form__select--sm"
                                  style={customStyle.select}
                                  id="billingWhatsappNumberCountryCode"
                                  onChange={(e) => {
                                    setFieldValue('billingWhatsappNumberCountryCode', e.target.value);
                                  }}
                                  disabled={sameAsPhoneNo || sameAsHomeAddress || !isDataAvailable}
                                  value={values.billingWhatsappNumberCountryCode}
                                >
                                {commonData?.countryCode?.map((option) => (
                                  <option
                                    key={option}
                                    value={option}
                                  >
                                    {option}
                                  </option>
                                ))}
                                </select>
                                <input
                                  type="text"
                                  className="form__input form__input--sm"
                                  id="billingWhatsappNumber"
                                  name="billingWhatsappNumber"
                                  placeholder="Whatsapp Number"
                                  onChange={handleChange}
                                  disabled={sameAsPhoneNo || sameAsHomeAddress || !isDataAvailable}
                                  maxLength={10}
                                  max={10}
                                  onKeyDown={(event) => {
                                    if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'Tab') {
                                      event.preventDefault();
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  value={
                                    sameAsPhoneNo ? getLocalPhoneNumber(values.billingPhoneNumber) : values.billingWhatsappNumber
                                  }
                                />
                              </div>
                              <div className="form__checkboxSubField">
                                <div className="form__checkbox">
                                  <div className="form__checkbox__option m_0">
                                    <input
                                      className="form__checkbox__input"
                                      id='sameAsContact'
                                      disabled={sameAsHomeAddress || !isDataAvailable}
                                      checked={sameAsPhoneNo}
                                      type="checkbox"
                                      name="sameAsContact"
                                      value="sameAsContact"
                                      onChange={(e) => {
                                        setSameAsPhoneNo(!sameAsPhoneNo);
                                        if (sameAsPhoneNo) {
                                          setFieldValue('billingWhatsappNumber', '');
                                          countryCode.billingWhatsappNumberCountryCode = "+91";
                                        }
                                      }}
                                    />
                                    <label htmlFor="sameAsContact" className="form__checkbox__label"> Same as Contact Number</label>
                                  </div>
                                </div>
                              </div>
                              <ErrorMessage name="whatsappNumber" component="div" className="error text-error" />
                            </div>
                          </div>
                        </div>
                        <div className='formRow formRow__4'>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='referringDoctorSpeciality'>
                                Zip Code
                              </label>
                              <input className="form__input form__input--sm"
                                type="text"
                                id="billingZipCode"
                                name="billingZipCode"
                                placeholder="Zip Code"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={sameAsHomeAddress || !isDataAvailable}
                                value={
                                  sameAsHomeAddress ? values.billingZipCode = patientDetails?.billingInfo?.zipCode : values.billingZipCode
                                }
                              />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label">
                                Country
                              </label>
                              <select
                                className="form__select form__select--sm"
                                id="billingCountry"
                                name="billingCountry"
                                style={customStyle.select}
                                onChange={(e) => {
                                  handleChange(e)
                                  fetchStates(e.target.value, '', 'state')
                                }}
                                disabled={sameAsHomeAddress || !isDataAvailable}
                                onBlur={handleBlur}
                                value={
                                  sameAsHomeAddress ? values.billingCountry = patientDetails?.billingInfo?.country : values.billingCountry
                                }
                              >
                                <option value="" disabled>-Select-</option>
                                {commonData?.countryList?.map((option: any) => {
                                  return <option key={option.value} value={option.value}>
                                    {option.name}
                                  </option>
                                })}
                              </select>
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label">
                                State
                              </label>
                              <select
                                className="form__select form__select--sm"
                                id="billingState"
                                name="billingState"
                                style={customStyle.select}
                                onChange={(e) => {
                                  handleChange(e)
                                  fetchStates(values.billingCountry, e.target.value, 'city')
                                }}
                                onBlur={handleBlur}
                                disabled={sameAsHomeAddress || !isDataAvailable}
                                aria-label={sameAsHomeAddress && 'billingState'}
                                value={
                                  sameAsHomeAddress ? values.billingState = patientDetails?.billingInfo?.state : values.billingState
                                }
                              >
                                {
                                  sameAsHomeAddress ? <option selected value={patientDetails?.billingInfo?.state}>{patientDetails?.billingInfo?.state}</option> : <option value="" disabled>-Select-</option>
                                }
                                {state?.map((option) => (
                                  <option key={option.isoCode} value={option.isoCode}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label">
                                City
                              </label>
                              <select
                                className="form__select form__select--sm"
                                id="billingCity"
                                name="billingCity"
                                style={customStyle.select}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={sameAsHomeAddress || !isDataAvailable}
                                value={
                                  sameAsHomeAddress ? values.billingCity = patientDetails?.billingInfo?.city : values.billingCity
                                }
                              >
                                {sameAsHomeAddress ?
                                  <option selected value={patientDetails?.billingInfo?.city}>{patientDetails?.billingInfo?.city}</option> :
                                  <option value="" disabled>-Select-</option>
                                }
                                {cities?.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className='formRow formRow__4'>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='billingAlternateNumberCountryCode'>
                                Alternate Number
                              </label>
                              <div className='form__groupField form__groupField--phonenumber'>
                                <select className="form__select form__select--sm"
                                  style={customStyle.select}
                                  id="billingAlternateNumberCountryCode"
                                  onChange={(e) => {
                                    setFieldValue('billingAlternateNumberCountryCode', e.target.value);
                                  }}
                                  disabled={sameAsHomeAddress || !isDataAvailable}
                                  value={values.billingAlternateNumberCountryCode}
                                >
                                  {commonData?.countryCode?.map((option) => (
                                    <option
                                      key={option}
                                      value={option}
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <input type="text"
                                  className="form__input form__input--sm"
                                  id="billingAlternateNumber"
                                  name="billingAlternateNumber"
                                  placeholder="Alternate Number"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={sameAsHomeAddress || !isDataAvailable}
                                  maxLength={10}
                                  max={10}
                                  onKeyDown={(event) => {
                                    if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'Tab') {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={sameAsHomeAddress ? values.billingAlternateNumber = getLocalPhoneNumber(patientDetails?.billingInfo?.alternateMobileNo) : values.billingAlternateNumber}>
                                </input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      {appointmentType === "investigation_with_modality" && values?.quesInfo?.length > 0 && (
                        <section className="form__section">
                          <h1 className="form__section__title">Other Questions*</h1>
                          <FieldArray name="quesInfo">
                            {({ remove, push }) => {
                              const uniqueQuestions = [];
                              const seenQuestionIds = new Set();

                              values.quesInfo.forEach((question, index) => {
                                if (question && question._id && !seenQuestionIds.has(question._id)) {
                                  seenQuestionIds.add(question._id);
                                  uniqueQuestions.push({ ...question, originalIndex: index });
                                }
                              });

                              return (
                                <>
                                  {uniqueQuestions.map((question) => {
                                    const actualIndex = question.originalIndex;
                                    return (
                                      <div className="flex items-center mt-5" key={question._id}>
                                        <label className={`mr-4 w-1/3 ${isDarkMode?.isDarkMode ? "text-white" : "text-gray-700"}`}>
                                          {question.question}
                                        </label>
                                        <div className="flex items-center">
                                          {['true', 'false'].map((option) => (
                                            <label key={option} className="flex items-center mr-8 custom-radio-container">
                                              <Field
                                                disabled={!isDataAvailable}
                                                type="radio"
                                                name={`quesInfo[${actualIndex}].answer`}
                                                value={option}
                                                checked={values.quesInfo[actualIndex]?.answer === option}
                                                onChange={() => setFieldValue(`quesInfo[${actualIndex}].answer`, option)}
                                                className="form-radio text-indigo-600"
                                              />
                                              <span className="custom-radio"></span>
                                              <span className={`ml-2 ${isDarkMode?.isDarkMode ? "text-white" : "text-gray-700"}`}>
                                                {option === 'true' ? 'Yes' : 'No'}
                                              </span>
                                            </label>
                                          ))}
                                        </div>
                                        {errors.quesInfo?.[actualIndex]?.answer && touched.quesInfo?.[actualIndex]?.answer && (
                                          <div className="text-red-500 text-sm">{errors.quesInfo[actualIndex].answer}</div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </>
                              );
                            }}
                          </FieldArray>
                        </section>
                      )}

                      <section className='form__section'>
                        <div className='btn__group'>
                          <button
                            className='btn btn__primary'
                            type="submit"
                            disabled={
                              !isDataAvailable
                            }
                          >
                            {mode === "edit" ? "Update Appointment" : "Book Appointment"}
                          </button>
                           <button
                            className='btn btn__white'
                            onClick={cancel}
                          >
                            Cancel
                          </button>
                        </div>
                      </section>
                    </Form>
                  )
                }
                }
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
        isSuccessModalOpen={modal}
        title={title}
        handleCloseModal={() => setModal(false)}
      />
      <Loader
        isLoaderOpen={loading}
        title={title}
        handleCloseModal={() => setModal(false)}
      />
    </>
  )
}

export default AddEditAppointments
